import './NewVendor.css'
import Logo from '../refs/CornerstoneColor.jpg';
import { useEffect, useState } from 'react';
import { useSearchParams,useParams } from "react-router-dom";
import { ImCheckboxUnchecked, ImCheckboxChecked  } from "react-icons/im";
import { FaStar, FaCheck, FaDotCircle, FaLock  } from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";
import newVendorRequestService from '../Services/VendorRequestService';
import LoadingSpinner from '../Components/LoadingSpinner';
import newVendorDataService from "../Services/NewVendorService";
import CryptoJS from 'crypto-js';

// API SUPPORT CALLS - - - - - - - - - - -
const sendVoidedCheck = async (voidCheck, filename, setVoidedCheckId, setVoidedCheckError) => {
    newVendorDataService.submitVoidedCheck(voidCheck,filename)
    .then(response =>{
        setVoidedCheckId(response.data.id);

    }).catch( e=> {
        setVoidedCheckError(e.toString());

    });
};

const sendCoi = async (coi, filename, setCoiId, setCoiError) => {
    newVendorDataService.submitCoi(coi,filename)
    .then(response =>{
        setCoiId(response.data.id);

    }).catch( e=> {
        setCoiError(e.toString());
    });
};

const getEncryptionKey = (setTo, setError) => {
    newVendorDataService.getEncryptionKey()
    .then(response => {
        setTo(response.data.key);
    })
    .catch(e => {
        setError(e.toString());
    });
};

const sendVendorRecord = async (vendorObject, setFormComplete, setVendorRecordError, encryptionKey) => {
    // ENCRYPT SENSITIVE DATA BEFORE SENDING
    const encryptedVendorObject = { ...vendorObject };
    if (encryptedVendorObject.fedEinSSn) {
        encryptedVendorObject.fedEinSSn = encryptSensitiveData(encryptedVendorObject.fedEinSSn, encryptionKey);
    }
    if (encryptedVendorObject.bankAccountNumber) {
        encryptedVendorObject.bankAccountNumber = encryptSensitiveData(encryptedVendorObject.bankAccountNumber, encryptionKey);
    }
    
    newVendorDataService.submitVendorRecord(encryptedVendorObject)
    .then(response =>{
        setFormComplete();
    }).catch( e=> {
        setVendorRecordError(e.toString());
    });
};

const updateVendorRecord = async (vendorObject, setFormComplete, setVendorRecordError, encryptionKey) => {
    // ENCRYPT SENSITIVE DATA BEFORE SENDING
    const encryptedVendorObject = { ...vendorObject };
    if (encryptedVendorObject.fedEinSSn) {
        encryptedVendorObject.fedEinSSn = encryptSensitiveData(encryptedVendorObject.fedEinSSn, encryptionKey);
    }
    if (encryptedVendorObject.bankAccountNumber) {
        encryptedVendorObject.bankAccountNumber = encryptSensitiveData(encryptedVendorObject.bankAccountNumber, encryptionKey);
    }
    
    newVendorDataService.updateVendorRecord(encryptedVendorObject)
    .then(response =>{
        setFormComplete();
    }).catch( e=> {
        setVendorRecordError(e.toString());
    });
};

const getBlankW9 = () => {
    newVendorDataService.getW9()
};

const sendW9 = async (w9, filename, setW9Id, setW9Error) => {
    newVendorDataService.submitW9(w9,filename)
    .then(response =>{
        setW9Id(response.data.id);
    }).catch( e=> {
        setW9Error(e.toString());
    });
};

const sendInternationalWire = async (intWire, filename, setIntWireId, setIntWireError) => {
    newVendorDataService.submitIntWire(intWire,filename)
    .then(response =>{
        setIntWireId(response.data.id);
    }).catch( e=> {
        setIntWireError(e.toString());
    });
};

const sendBusinessClassification = async (businessClassification, filename, setBusinessClassificationId, setBusinessClassificationError) => {
    newVendorDataService.submitBusinessClassification(businessClassification,filename)
    .then(response =>{
        setBusinessClassificationId(response.data.id);
    }).catch( e=> {
        setBusinessClassificationError(e.toString());
    });
};

// FETCHES REJECTION RECORD
const grabRejectionRecord = async (sessionId,rejectionId,setRejectionRecord) => {
    newVendorRequestService.getRejectionRecord(sessionId, rejectionId).then(res => setRejectionRecord(res.data));
};

const getVendorRecord = async (sessionId, vendorId, setVendorRecord) => {
    newVendorRequestService.getVendorRecord(sessionId, vendorId).then(res => setVendorRecord(res.data));
};


// HELPER FUNCTIONS - - - - - - - - - - -
const getDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    
    today = mm + '.' + dd + '.' + yyyy;
    return today;
};

const formatPhoneNumber = (value) => {
    const digits = (value || '').replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const stripEinSsnSymbols = (value) => {
    return (value || '').replace(/[\D]/g, '').slice(0, 9);
};

const encryptSensitiveData = (data, encryptionKey) => {
    if (!encryptionKey) {
        console.error('Encryption key not available');
        return data;
    }
    return CryptoJS.AES.encrypt(data, encryptionKey).toString();
};

const SignatureInput = ({title,setTo,complete=false ,width=0, initializedValue=''}) => {
    const [displayWidth, setDisplayWidth ] = useState('auto');
    const [inputValue, setInputValue ] = useState(initializedValue || '');

    const inputCssProps = {
        '--inputWidth': `${displayWidth}`
    };

    useEffect(() => {
        if(width > 0) setDisplayWidth(`${width}px`)
        else setDisplayWidth('auto')
    },[])

    useEffect(() => {
        setInputValue(initializedValue || '');
    }, [initializedValue]);

    return(
        <>
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin='true'/>
        <link href="https://fonts.googleapis.com/css2?family=Whisper&display=swap" rel="stylesheet"/>

        <div className='External-Form-Input' style={inputCssProps}>
            {   !complete &&
                <FaStar className='External-Form-Input-Required' />
            }
            {   complete &&
                <FaCheck className='External-Form-Input-Complete' />
            }
            
            <div className='External-Form-Input-Title'>
                {title}
            </div>
            <input type="text" className='External-Form-Signature-Box' value={inputValue} onChange={(e) => {
                setInputValue(e.target.value);
                setTo(e.target.value);
            }} />
        </div>
        </>
    )
}

const TextInput = ({title,setTo, complete=false ,width=0,charCount=0,required=false,active=true, under=false, initializedValue=null, phoneFormat=false, einFormat=false, encrypted=false}) => {
    const [displayWidth, setDisplayWidth ] = useState('auto');
    const [inputValue, setInputValue ] = useState(initializedValue || '');

    const inputCssProps = {
        '--inputWidth': `${displayWidth}`
    };

    useEffect(() => {
        if(width>0){
            setDisplayWidth(`${width}px`)
        }
        else{
            if(charCount > 0){
                setDisplayWidth(`${charCount*18}px`);
            }
            else{
                setDisplayWidth('auto')
            }
        }
    },[])

    useEffect(() => {
        setInputValue(initializedValue || '');
    }, [initializedValue]);

    const handleInputChange = (value) => {
        if (phoneFormat) {
            const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
            setInputValue(digitsOnly);
            setTo(digitsOnly);
            return;
        }

        if (einFormat) {
            const digitsOnly = stripEinSsnSymbols(value);
            setInputValue(digitsOnly);
            setTo(digitsOnly);
            return;
        }

        setInputValue(value);
        setTo(value);
    };

    const displayValue = phoneFormat ? formatPhoneNumber(inputValue) : inputValue;

    if(!under){
        return(
            <div className='External-Form-Input' style={inputCssProps}>
                {   active && required && !complete &&
                <FaStar className='External-Form-Input-Required' />
                }
                {   active && !required && !complete &&
                <FaStar className='External-Form-Input-Not-Required' />
                }
                {   active && complete &&
                <FaCheck className='External-Form-Input-Complete' />
                }
                <div className='External-Form-Input-Title'>
                    {title}
                </div>
                <div className='External-Form-Input-Field'>
                    { encrypted &&
                    <FaLock className='External-Form-Input-Encrypted-Lock' />
                    }
                    {   charCount > 0 &&
                        <input type="text" placeholder={phoneFormat ? '(###) ###-####' : ''} value={displayValue || ''} inputMode={phoneFormat ? 'tel' : 'numeric'} maxLength={phoneFormat ? 14 : charCount} className={`External-Form-Input-Contrained${phoneFormat ? ' External-Form-Input-Phone' : ''}`} onChange={(e) => handleInputChange(e.target.value)}/>
                    }
                    {   charCount < 1 &&
                        <input type="text" placeholder='' value={displayValue || ''} className='External-Form-Input-Box' onChange={(e) => handleInputChange(e.target.value)} />
                    }
                </div>
                
            </div>
        )
    }
    else{
        return(
            <div className='External-Form-Input-Under' style={inputCssProps}>
                {   active && required && !complete &&
                <FaStar className='External-Form-Input-Required' />
                }
                {   active && !required && !complete &&
                <FaStar className='External-Form-Input-Not-Required' />
                }
                {   active && complete &&
                <FaCheck className='External-Form-Input-Complete' />
                }

                <div className='External-Form-Input-Field'>
                    { encrypted &&
                    <FaLock className='External-Form-Input-Encrypted-Lock' />
                    }
                    {   charCount > 0 &&
                        <input type="text" inputMode={phoneFormat ? 'tel' : 'numeric'} placeholder={phoneFormat ? '(###) ###-####' : ''} value={displayValue || ''} maxLength={phoneFormat ? 14 : charCount} className={`External-Form-Input-Contrained${phoneFormat ? ' External-Form-Input-Phone' : ''}`} onChange={(e) => handleInputChange(e.target.value)}/>
                    }
                    {   charCount < 1 &&
                        <input type="text" className='External-Form-Input-Box' placeholder='' value={displayValue || ''} onChange={(e) => handleInputChange(e.target.value)} />
                    }
                </div>

                <div className='External-Form-Input-Title-Under'>
                    {title}
                </div>
                
            </div>
        )
    }

};

const DropDownSelection = ({title, options, setTo, complete=false, width, active, required, initializedValue}) => {
    const [selectedValue, setSelectedValue] = useState(initializedValue || '');

    const inputCssProps = {
        '--inputWidth': `${width}`
    };

    useEffect(() => {
        setSelectedValue(initializedValue || '');
    }, [initializedValue]);

    const selectOption = (value) => {
         setSelectedValue(value);
         setTo(value);
    };

    return(
        <div className='External-Form-Input' style={inputCssProps}>
        {   active && required && !complete &&
        <FaStar className='External-Form-Input-Required' />
        }
        {   active && required && complete &&
        <FaCheck className='External-Form-Input-Complete' />
        }
        <div className='External-Form-Input-Title'>
            {title}
        </div>
        <select className='External-Form-Dropdown' value={selectedValue || ''} onChange={(e) => selectOption(e.target.value)}>
            <option value={''}> </option>
            {   options.map((option, key) => (
                <option className='External-Form-Dropdown-Selection' key={key} value={option}>{option}</option>
            ))
            }
        </select>

        
    </div>
    )
};

const AccountSelector = ({title, selected, setTo}) => {
    return(
        <div className='External-Vendor-Type-Selection-Group'>
            {   !selected &&
                <ImCheckboxUnchecked className='External-Vendor-Type-Selection' onClick={() => setTo(true)}/>
            }
            {   selected &&
                <ImCheckboxChecked className='External-Vendor-Type-Selection' onClick={() => setTo(false)}/>
            }
            <div className='External-Vendor-Type-Selection-Text'>
                {title}
            </div>
        </div>
    )
};

const ClassificationSelector = ({value,classificationList,addClassification,removeClassification}) => {
    const [selected, setSelected] = useState(false);

    useEffect(() => {
        if(classificationList){
            if(classificationList.includes(value)){
                setSelected(true);
            }
            else setSelected(false);
        }
        else setSelected(false);

    },[classificationList]);

    return(
        <div className='External-Vendor-Type-Selection-Group'>
            {   !selected &&
                <ImCheckboxUnchecked className='External-Vendor-Type-Selection' onClick={() => addClassification(value)}/>
            }
            {   selected &&
                <ImCheckboxChecked className='External-Vendor-Type-Selection' onClick={() => removeClassification(value)}/>
            }
            <div className='External-Vendor-Type-Selection-Text'>
                {value}
            </div>
        </div>
    )
};

const checkEmail = (email) => {
    let valid = true;
    try{
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
        if(re.test(email)){
            // Valid Email
        }
        else{
            valid = false;
        }
    }
    catch{
        valid = false;
    }

    return valid;
};


// DISPLAY SECTIONS - - - - - - - - - -

// HEADER FOR FORM
const FormHeader = ({formEmail}) => {
    return(
        <div className='External-Form-Header'>
            <img src={Logo} className='External-Form-Logo' alt='Cornerstone Logo'/>

            <div className='External-Form-Contact'>
                <div className='External-Form-Contact-Content'>
                    2511 Midpark Road, Montgomery, AL 36109
                </div>
                <div className='External-Form-Contact-Content'>
                    (334) 281-8440
                </div>
            </div>
            <div className='External-Form-Email-Support'>
                {formEmail}
            </div>
            <div className='External-Vendor-Title'>
                    New Vendor Form
            </div>
        </div>
    )
};

// VENDOR TYPE SECTION
const VendorType = ({typeActive,formType,handleFormTypeSelection}) => {
    return(
        <div className='External-Vendor-Type'>

        {   typeActive &&
            <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                Are you a new vendor or updating information for an existing vendor?
            </div>
        }


        <div className='External-Vendor-Type-Selections'>
            <div className='External-Vendor-Type-Selection-Group'>
                {   formType === 'New' &&
                    <ImCheckboxChecked className='External-Vendor-Type-Selection'/>
                }
                {   formType !== 'New' &&
                    <ImCheckboxUnchecked className='External-Vendor-Type-Selection' onClick={() => handleFormTypeSelection('New')}/>
                }
                <div className='External-Vendor-Type-Selection-Text'>
                    New Vendor
                </div>
            </div>

            <div className='External-Vendor-Type-Selection-Group'>
                {   formType === 'Update' &&
                    <ImCheckboxChecked className='External-Vendor-Type-Selection'/>
                }
                {   formType !== 'Update' &&
                    <ImCheckboxUnchecked className='External-Vendor-Type-Selection' onClick={() => handleFormTypeSelection('Update')}/>
                }
                <div className='External-Vendor-Type-Selection-Text'>
                    Update Vendor
                </div>
            </div>
            
        </div>

    </div>
    )
};

// VENDOR INFORMATION SECTION
const VendorInformation = ({formType,vendorInformationActive,setFedEinSSn,fedEinSSn,fedEinSSnComplete,setLegalName,legalName,
    legalNameComplete,setBusinessName,businessName,businessNameComplete,setStreet,street,setStreet2,street2,streetComplete,setCity,city,cityComplete,
    setState,state,stateComplete,setZip,zip,zipComplete,setCountry,country}) => {

    const [addressComplete, setAddressComplete] = useState(false);

    useEffect(() => {
        if(stateComplete && cityComplete && stateComplete && zipComplete) setAddressComplete(true);
        else setAddressComplete(false);
    },[streetComplete,cityComplete,stateComplete,zipComplete]);

    return(
        <>
        {   formType &&
            <div className='External-Vendor-Information'>
                {   vendorInformationActive &&
                    <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please Fill in the Vendor/Payee Information Below.
                    </div>
                    </>
                }
                {   !vendorInformationActive &&
                    <>
                    <div className='External-Vendor-Type-Title'>
                        Vendor/Payee
                    </div>
                    </>
                }
                <TextInput title={'Federal EIN/SSN:'} setTo={setFedEinSSn} complete={fedEinSSnComplete} charCount={9} required={true} active={vendorInformationActive} initializedValue={fedEinSSn} einFormat={true} encrypted={true}/>
                <TextInput title={'Legal Name:'} setTo={setLegalName} complete={legalNameComplete} width={340} required={true} active={vendorInformationActive} initializedValue={legalName}/>
                <TextInput title={'Payee/Business Name:'} setTo={setBusinessName} complete={businessNameComplete} width={600} required={true} active={vendorInformationActive} initializedValue={businessName}/>

                <div className='External-Form-Spacer'>

                </div>
                <div className='External-Form-Input-Title'>
                Business Address:
                </div>
                <TextInput title={'Street:'} setTo={setStreet} complete={streetComplete} width={220} required={true} active={vendorInformationActive} under={true} initializedValue={street}/>
                <TextInput title={'Street2:'} setTo={setStreet2} width={120} required={false} active={vendorInformationActive} under={true} initializedValue={street2}/>
                <TextInput title={'City:'} setTo={setCity} complete={cityComplete} width={140} required={true} active={vendorInformationActive} under={true} initializedValue={city}/>
                <TextInput title={'State/Province:'} setTo={setState} complete={stateComplete} charCount={2} width={70} required={true} active={vendorInformationActive} under={true} initializedValue={state}/>
                <TextInput title={'Zip:'} setTo={setZip} complete={zipComplete} charCount={6} required={true} active={vendorInformationActive} under={true} initializedValue={zip}/>
                <DropDownSelection title={'Country:'} options={['USA', 'MEX', 'CAN']} setTo={setCountry} required={false} active={vendorInformationActive} initializedValue={country}/>

                {   !fedEinSSnComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Federal EIN or SSN to continue.
                </div>
                }
                {   !legalNameComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Legal Name to continue.
                </div>
                }
                {   !businessNameComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Business Name to continue.
                </div>
                }
                {   !addressComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Address to continue.
                </div>
                }
            </div>
        }
        </>
    )
};

// CONTACTS SECTIONS
const ContactInformation = ({contactInformationShown,contactInformationActive,primaryContactFirstName,primaryContactLastName,setPrimaryContactFirstName,setPrimaryContactLastName,primaryContactTitle,setPrimaryContactTitle,primaryContactFirstNameComplete,primaryContactLastNameComplete,
    setPrimaryContactNumber,primaryContactNumber,primaryContactNumberComplete,setPrimaryContactNumberExtension,primaryContactNumberExtension,
    setPrimaryContactEmail,primaryContactEmail,primaryContactEmailComplete,
    }) => {

    return(
        <>
        {   contactInformationShown &&
            <div className='External-Vendor-Information'>
                {   contactInformationActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please Fill in the Primary Contact Information Below.
                    </div>
                    
                </>
                }
                {   !contactInformationActive &&
                <>
                    <div className='External-Vendor-Type-Title'>
                        Primary Contact
                    </div>
                    
                </>
                }
                <div className='External-Vendor-Contact-Group'>
                    <TextInput title={'First Name:'} setTo={setPrimaryContactFirstName} complete={primaryContactFirstNameComplete} width={160} required={true} active={contactInformationActive} initializedValue={primaryContactFirstName}/>
                    <TextInput title={'Last Name:'} setTo={setPrimaryContactLastName} complete={primaryContactLastNameComplete} width={160} required={true} active={contactInformationActive} initializedValue={primaryContactLastName}/>
                    <TextInput title={'Job Title:'} setTo={setPrimaryContactTitle} width={160} required={false} active={contactInformationActive} initializedValue={primaryContactTitle}/>
                    <TextInput title={'Telephone:'} setTo={setPrimaryContactNumber} complete={primaryContactNumberComplete} charCount={10} required={true} active={contactInformationActive} initializedValue={primaryContactNumber} phoneFormat={true}/>
                    <TextInput title={'Extension'} setTo={setPrimaryContactNumberExtension} charCount={6} required={false} active={contactInformationActive}  initializedValue={primaryContactNumberExtension}/>
                    <TextInput title={'Email Address:'} setTo={setPrimaryContactEmail} complete={primaryContactEmailComplete} width={280} required={true} active={contactInformationActive}  initializedValue={primaryContactEmail}/>
                </div>

                {   !primaryContactFirstNameComplete || !primaryContactLastNameComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Primary Contact Name to continue.
                </div>
                }
                {   !primaryContactNumberComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Primary Contact Number to continue.
                </div>
                }
                {   !primaryContactEmailComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Primary Contact Email Address to continue.
                </div>
                }
            </div>

        }
        </>
    )
};

// Reimttance Section
const RemitInformation = ({remitInformationShown,remitInformationActive,
    remitFirstName1,remitLastName1,setRemitFirstName1,setRemitLastName1,remitFirstName1Complete,remitLastName1Complete,
    remitTitle1,setRemitTitle1,setRemitNumber1,remitNumber1,remitNumber1Complete,remitNumberExtension1,setRemitNumberExtension1,
    remitEmail1,setRemitEmail1,remitEmail1Complete,
    remitContact2,setRemitContact2,
    remitFirstName2,remitLastName2,setRemitFirstName2,setRemitLastName2,remitFirstName2Complete,remitLastName2Complete,
    remitTitle2,setRemitTitle2,setRemitNumber2,remitNumber2,remitNumber2Complete,setRemitNumberExtension2,remitNumberExtension2,
    remitEmail2,setRemitEmail2,remitEmail2Complete,primaryContactFirstName,primaryContactLastName,primaryContactTitle,primaryContactNumber,primaryContactNumberExtension,primaryContactEmail }) => {

        const [remitSameAsPrimary, setRemitSameAsPrimary] = useState(false);

        useEffect(() => {
            if((remitFirstName1 === primaryContactFirstName) && (remitLastName1 === primaryContactLastName)) setRemitSameAsPrimary(true);
            else setRemitSameAsPrimary(false);
        },[remitFirstName1, remitLastName1, primaryContactFirstName, primaryContactLastName]);

        useEffect(() => {
            if(remitSameAsPrimary){
                setRemitFirstName1(primaryContactFirstName);
                setRemitLastName1(primaryContactLastName);
                setRemitTitle1(primaryContactTitle);
                setRemitNumber1(primaryContactNumber);
                setRemitNumberExtension1(primaryContactNumberExtension);
                setRemitEmail1(primaryContactEmail);
            }

        },[remitSameAsPrimary, remitFirstName1, remitLastName1, remitTitle1, remitNumber1, remitNumberExtension1, remitEmail1]);


        return(
            <>
            {   remitInformationShown &&
            <div className='External-Vendor-Information'>
                {   !remitSameAsPrimary &&
                    <button onClick={() => setRemitSameAsPrimary(true)} className='External-Vendor-Contact-Button Button-Add'>Set Remittance Contact Same as Primary Contact</button>
                }
                {   remitSameAsPrimary &&
                    <button onClick={() => setRemitSameAsPrimary(false)} className='External-Vendor-Contact-Button Button-Add'>Remittance Contact Differs from Primary Contact</button>
                }

                {   remitInformationActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please Fill in the Remittance Contact Information Below.
                    </div>
                    <div className='External-Vendor-Type-Subtitle External-Vendor-Italic'>
                        Remittance will be sent to both contacts if secondary is added.
                    </div>
                </>
                }

                {   !remitInformationActive &&
                <>
                    <div className='External-Vendor-Type-Title'>
                        Remittance Contacts
                    </div>
                </>
                }
                <div className='External-Vendor-Remit-Group'>
                    <TextInput title={'First Name:'} setTo={setRemitFirstName1} complete={remitFirstName1Complete} width={160} required={true} active={remitInformationActive} initializedValue={remitFirstName1}/>
                    <TextInput title={'Last Name:'} setTo={setRemitLastName1} complete={remitLastName1Complete} width={160} required={true} active={remitInformationActive} initializedValue={remitLastName1}/>
                    <TextInput title={'Job Title:'} setTo={setRemitTitle1} width={160} required={false} active={remitInformationActive} initializedValue={remitTitle1}/>
                    <TextInput title={'Telephone:'} setTo={setRemitNumber1} complete={remitNumber1Complete} charCount={10} required={true} active={remitInformationActive} initializedValue={remitNumber1} phoneFormat={true}/>
                    <TextInput title={'Extension'} setTo={setRemitNumberExtension1} charCount={6} required={false} active={remitInformationActive}  initializedValue={remitNumberExtension1}/>
                    <TextInput title={'Email Address:'} setTo={setRemitEmail1} complete={remitEmail1Complete} width={280} required={true} active={remitInformationActive}  initializedValue={remitEmail1}/>
                </div>

                {   !remitContact2 && !remitSameAsPrimary &&
                <button onClick={() => setRemitContact2(true)} className='External-Vendor-Contact-Button Button-Add'>Add Secondary Contact</button>
                }
                {   remitContact2 && remitInformationActive &&
                   <button onClick={() => setRemitContact2(false)} className='External-Vendor-Contact-Button Button-Remove'>Remove Secondary Contact</button>
                }

                {   remitContact2 &&
                <div className='External-Vendor-Remit-Group'>
                    <TextInput title={'First Name:'} setTo={setRemitFirstName2} complete={remitFirstName2Complete} width={160} required={true} active={remitInformationActive} initializedValue={remitFirstName2}/>
                    <TextInput title={'Last Name:'} setTo={setRemitLastName2} complete={remitLastName2Complete} width={160} required={true} active={remitInformationActive} initializedValue={remitLastName2}/>
                    <TextInput title={'Job Title:'} setTo={setRemitTitle2} width={160} required={false} active={remitInformationActive} initializedValue={remitTitle2}/>
                    <TextInput title={'Telephone:'} setTo={setRemitNumber2} complete={remitNumber2Complete} charCount={10} required={true} active={remitInformationActive} initializedValue={remitNumber2} phoneFormat={true}/>
                    <TextInput title={'Extension'} setTo={setRemitNumberExtension2} charCount={6} required={false} active={remitInformationActive}  initializedValue={remitNumberExtension2}/>
                    <TextInput title={'Email Address:'} setTo={setRemitEmail2} complete={remitEmail2Complete} width={280} required={true} active={remitInformationActive}  initializedValue={remitEmail2}/>
                </div>
                }

                {   !remitFirstName1Complete || !remitLastName1Complete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Remittance Contact Name to continue.
                </div>
                }
                {   !remitNumber1Complete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Remittance Contact Number to continue.
                </div>
                }
                {   !remitEmail1Complete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Remittance Contact Email Address to continue.
                </div>
                }

                {   remitContact2 && (!remitFirstName2Complete || !remitLastName2Complete) &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Secondary Remittance Name to continue.
                </div>
                }
                {   !remitNumber2Complete && remitContact2 &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Secondary Remittance Number to continue.
                </div>
                }
                {   !remitEmail2Complete && remitContact2 &&
                <div  className='External-Vendor-Type-Error'>
                    Enter a Valid Secondary Remittance Email Address to continue.
                </div>
                }

            </div>

        }
            </>
        )
};

// PAYMENT SECTION
const PaymentInformation = ({paymentInformationShown,paymentInformationActive,vendorTypeOptions, setVendorTypeSelection, vendorTypeSelection, vendorTypeSelectionComplete,
    paymentTypes,setPaymentMethod,paymentMethod, paymentMethodComplete,paymentTermsComplete, 
    setInvoiceCurrency,setPaymentTermNames,paymentTermNamesOptions,paymentTermNames,paymentTermNamesComplete,invoiceCurrency,invoiceCurrencyOptions,invoiceCurrencyComplete,customTermsShown, setCustomTerms,businessClassifications, 
    classificationList, setClassificationList, editClassificationList=null}) => {

    const addClassification = (value) => {
        let newList = classificationList.filter(item => item !== value);
        newList.push(value);
        setClassificationList(newList);
    };

    const removeClassification = (value) => {
        let newList = classificationList.filter(item => item !== value);
        setClassificationList(newList);
    };

    return(
        <>
        {   paymentInformationShown &&
            <div className='External-Vendor-Information'>
                {   paymentInformationActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please Fill out the Vendor Type and Payment Method.
                    </div>
                </>
                }
                {   !paymentInformationActive &&
                <>
                    <div className='External-Vendor-Type-Title'>
                        Vendor Type and Payment Method
                    </div>
                </>
                }
                <DropDownSelection title={'Vendor Type:'} setTo={setVendorTypeSelection} complete={vendorTypeSelectionComplete} options={vendorTypeOptions} required={true} active={paymentInformationActive} initializedValue={vendorTypeSelection}/>
                <DropDownSelection title={'Payment Method:'} setTo={setPaymentMethod} complete={paymentMethodComplete} options={paymentTypes} required={true} active={paymentInformationActive} initializedValue={paymentMethod}/>
                <DropDownSelection title={'Payment Terms:'} setTo={setPaymentTermNames} complete={paymentTermNamesComplete} options={paymentTermNamesOptions} required={true} active={paymentInformationActive} initializedValue={paymentTermNames}/>
                <DropDownSelection title={'Invoice Currency:'} setTo={setInvoiceCurrency} complete={invoiceCurrencyComplete} options={invoiceCurrencyOptions} required={true} active={paymentInformationActive} initializedValue={invoiceCurrency}/>
                {   customTermsShown &&  
                    <TextInput title={'Custom Terms'} setTo={setCustomTerms} width={800} required={true} active={paymentInformationActive}/>
                }

                <div className='External-Vendor-Selection-Section'>
                <div className='External-Vendor-Type-Subtitle'>
                    Business Classifications
                </div>
                    {   
                        businessClassifications.map((value, key) => (
                            <ClassificationSelector key={key} value={value} classificationList={classificationList} addClassification={addClassification} removeClassification={removeClassification}/>
                        ))
                    }
                </div>

                {   !vendorTypeSelectionComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Select a valid Vendor Type to continue.
                </div>
                }
                {   !paymentMethodComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Select a valid Payment Method to continue.
                </div>
                }
                {   !paymentTermNamesComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter valid Payment Terms to continue.
                </div>
                }
                {   !invoiceCurrencyComplete &&
                <div  className='External-Vendor-Type-Error'>
                    Enter valid Invoice Currency to continue.
                </div>
                }
            </div>
        }
        </>
    )
};

// COI SECTION
const CoiInformation = ({coiActive, setCoiFile}) => {
    return(
        <div className='External-Vendor-Information'>
            {   coiActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please provide a Certificate of Insurance (COI) below.
                    </div>
                </>
            }
            {   !coiActive &&
                <>
                    <div className='External-Vendor-Thick-Spacer'/>
                    <div className='External-Vendor-Type-Title'>
                        Certificate of Insurance (COI)
                    </div>
                </>
            }
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>
            PDF version of COI :
            </div>
            <input type='file' accept="application/pdf" onChange={(e) => setCoiFile(e.target.files)} className='External-Form-File-Upload'/>
        </div>
    )
};

const BusinessClassificationInformation = ({businessClassificationActive, setBusinessClassification}) => {
    return(
        <div className='External-Vendor-Information'>
            {   businessClassificationActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please provide a proof of Business Classification below.
                    </div>
                </>
            }
            {   !businessClassificationActive &&
                <>
                    <div className='External-Vendor-Thick-Spacer'/>
                    <div className='External-Vendor-Type-Title'>
                        Proof of Business Classification
                    </div>
                </>
            }
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>
            PDF version of Proof of Business Classification :
            </div>
            <input type='file' accept="application/pdf" onChange={(e) => setBusinessClassification(e.target.files)} className='External-Form-File-Upload'/>
        </div>
    )
};

// ACH SECTION
const AchInformation = ({achActive,setBankName,bankName,bankNameComplete,setBankContactFirstName,bankContactFirstName,setBankContactLastName,bankContactLastName,bankContactFirstNameComplete,bankContactLastNameComplete,
    setBankStreet,bankStreet,setBankStreet2,bankStreet2,bankStreetComplete,setBankCity,bankCity,bankCityComplete,setBankState,bankState,bankStateComplete,
    setBankZip,bankZip,bankZipComplete,setBankCountry,bankCountry,bankCountryComplete,setBankTelephone,bankTelephone,bankTelephoneComplete,
    setBankContactEmail,bankContactEmail,bankContactEmailComplete,
    setBankVendorStreet,bankVendorStreet,setBankVendorStreet2,bankVendorStreet2,bankVendorStreetComplete,setBankVendorCity,bankVendorCity,bankVendorCityComplete,setBankVendorState,bankVendorState,bankVendorStateComplete,
    setBankVendorZip,bankVendorZip,bankVendorZipComplete,setBankVendorCountry,bankVendorCountry,
    setBankAccountName,bankAccountName,bankAccountNameComplete,
    setBankAccountNumber,bankAccountNumber,bankAccountNumberComplete,setBankRoutingNumber,bankRoutingNumber,bankRoutingNumberComplete,
    setBankAccountSelection,bankAccountSelection,bankAccountSelectionComplete}) => {
    
    const [ checkingSelected, setCheckingSelected ] = useState(true);
    const [ savingsSelected, setSavingsSelected ] = useState(false);
    const [ addressComplete, setAddressComplete] = useState(false);
    const [ vendorAddressComplete, setVendorAddressComplete ] = useState(false);

    useEffect(() => {
        if(bankStateComplete && bankCityComplete && bankStateComplete && bankZipComplete) setAddressComplete(true);
        else setAddressComplete(false);
    },[bankStateComplete,bankCityComplete,bankStateComplete,bankZipComplete]);

    useEffect(() => {
        if(bankVendorStreetComplete && bankVendorCityComplete && bankVendorStateComplete && bankVendorZipComplete) setVendorAddressComplete(true);
        else setVendorAddressComplete(false);
    },[bankVendorStreetComplete,bankVendorCityComplete,bankVendorStateComplete,bankVendorZipComplete]);


    const toggleSelection = (value) => {
        if(value === 'Checking'){
            setSavingsSelected(false);
            setCheckingSelected(true);
            setBankAccountSelection('Checking');
        }
        else{
            setSavingsSelected(true);
            setCheckingSelected(false);
            setBankAccountSelection('Savings');
        }
    };

    useEffect(() => {
        if(bankAccountSelection === 'Checking'){
            setSavingsSelected(false);
            setCheckingSelected(true);
        }
        else{
            setSavingsSelected(true);
            setCheckingSelected(false);
        }
    },[bankAccountSelection]);

    return(
        <div className='External-Vendor-Information'>
            { achActive &&
            <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                Please Fill in the ACH Payment Information Below.
            </div>
            }
            {   !achActive &&
                <div className='External-Vendor-Type-Title'>
                    ACH Payment Information
                </div>
            }
                
            <TextInput title={'Bank Name:'} setTo={setBankName} complete={bankNameComplete} width={280} required={true} active={achActive} initializedValue={bankName}/>
            <TextInput title={'Name on Account:'} setTo={setBankAccountName} complete={bankAccountNameComplete} width={300} required={true} active={achActive} initializedValue={bankAccountName}/>
            <div className='External-Form-Input-Title'>
            Address on Account:
            </div>
            <TextInput title={'Street:'} setTo={setBankVendorStreet} complete={bankVendorStreetComplete} width={220} required={true} active={achActive} under={true} initializedValue={bankVendorStreet}/>
            <TextInput title={'Street2:'} setTo={setBankVendorStreet2} width={120} required={false} active={achActive} under={true} initializedValue={bankVendorStreet2}/>
            <TextInput title={'City:'} setTo={setBankVendorCity} complete={bankVendorCityComplete} width={140} required={true} active={achActive} under={true} initializedValue={bankVendorCity}/>
            <TextInput title={'State/Province:'} setTo={setBankVendorState} complete={bankVendorStateComplete} charCount={2} width={70} required={true} active={achActive} under={true} initializedValue={bankVendorState}/>
            <TextInput title={'Zip:'} setTo={setBankVendorZip} complete={bankVendorZipComplete} charCount={6} required={true} active={achActive} under={true} initializedValue={bankVendorZip}/>
            <DropDownSelection title={'Country:'} options={['USA', 'MEX', 'CAN']} setTo={setBankVendorCountry} required={false} active={achActive} initializedValue={bankVendorCountry}/>
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>
            Bank Address:
            </div>
            <TextInput title={'Street:'} setTo={setBankStreet}complete={bankStreetComplete} width={220} required={true} active={achActive} under={true} initializedValue={bankStreet}/>
            <TextInput title={'Street2:'} setTo={setBankStreet2} width={120} required={false} active={achActive} under={true} initializedValue={bankStreet2}/>
            <TextInput title={'City:'} setTo={setBankCity} complete={bankCityComplete} width={140} required={true} active={achActive} under={true} initializedValue={bankCity}/>
            <TextInput title={'State/Province:'} setTo={setBankState} complete={bankStateComplete} charCount={2} width={70} required={true} active={achActive} under={true} initializedValue={bankState}/>
            <TextInput title={'Zip:'} setTo={setBankZip} complete={bankZipComplete} charCount={6} required={true} active={achActive} under={true} initializedValue={bankZip}/>
            <DropDownSelection title={'Country:'} options={['USA', 'MEX', 'CAN']} setTo={setBankCountry} required={false} active={achActive} initializedValue={bankCountry}/>
            <div className='External-Form-Spacer'>
            </div>

            <TextInput title={'Bank Telephone:'} setTo={setBankTelephone} complete={bankTelephoneComplete} charCount={10} required={true} active={achActive} initializedValue={bankTelephone} phoneFormat={true}/>
            <TextInput title={'Bank Contact First Name:'} setTo={setBankContactFirstName} complete={bankContactFirstNameComplete} width={150} required={true} active={achActive} initializedValue={bankContactFirstName}/>
            <TextInput title={'Bank Contact Last Name:'} setTo={setBankContactLastName} complete={bankContactLastNameComplete} width={150} required={true} active={achActive} initializedValue={bankContactLastName}/>
            <TextInput title={'Bank Contact Email:'} setTo={setBankContactEmail} complete={bankContactEmailComplete} width={300} required={true} active={achActive} initializedValue={bankContactEmail}/>
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Spacer'>
            </div>
            <TextInput title={'Account Number:'} setTo={setBankAccountNumber} complete={bankAccountNumberComplete} charCount={17} required={true} active={achActive} initializedValue={bankAccountNumber} encrypted={true}/>
            <TextInput title={'Routing Number:'} setTo={setBankRoutingNumber} complete={bankRoutingNumberComplete} charCount={9} required={true} active={achActive} initializedValue={bankRoutingNumber}/>
            

            <div className='External-Vendor-Account-Selection-Row'>
                <AccountSelector title={'Checking'} selected={checkingSelected} setTo={() => toggleSelection('Checking')}/>
                <AccountSelector title={'Savings'} selected={savingsSelected} setTo={() => toggleSelection('Savings')}/>
            </div>

            {   !bankNameComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Name to continue.
            </div>
            }
            {   !bankAccountNameComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Name for the Bank Account to continue.
            </div>
            }
            {   !addressComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Address to continue.
            </div>
            }
            {   !bankTelephoneComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Telephone Number to continue.
            </div>
            }
            {   !bankContactFirstNameComplete || !bankContactLastNameComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Contact Name to continue.
            </div>
            }
            {   !bankContactEmailComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Contact Email to continue.
            </div>
            }
            {   !vendorAddressComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Vendor Address on Account to continue.
            </div>
            }
            {   !bankAccountNumberComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Account Number to continue.
            </div>
            }
            {   !bankRoutingNumberComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Routing Number to continue.
            </div>
            }
            {   !bankAccountSelectionComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a Valid Bank Account Type Selection to continue.
            </div>
            }
        </div>
    )
};

// INTERNATIONAL WIRE SECTION
const InternationWireInformation = ({intWireActive, setIntWire}) => {
    return(
        <div className='External-Vendor-Information'>
            {   intWireActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please provide International Wire Instructions below.
                    </div>
                </>
            }
            {
                !intWireActive &&
                <>
                    <div className='External-Vendor-Thick-Spacer'/>
                    <div className='External-Vendor-Type-Title'>
                        International Wire Instructions.
                    </div>
                </>
                
            }
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>
            PDF version of International Wire Instructions :
            </div>
            <input type='file' accept="application/pdf" onChange={(e) => setIntWire(e.target.files)} className='External-Form-File-Upload'/>
        </div>
    )
};

// VOIDED CHECK SECTION
const VoidedCheckInformation = ({voidedCheckActive, setVoidedCheckFile}) => {
    return(
        <div className='External-Vendor-Information'>
            {   voidedCheckActive &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please attach a Voided Check or a Bank Letter confirming the banking information above.
                    </div>
                </>
            }
            {
                !voidedCheckActive &&
                <>
                    <div className='External-Vendor-Thick-Spacer'/>
                    <div className='External-Vendor-Type-Title'>
                        Voided Check or Bank Letter 
                    </div>
                </>
            }
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>
            PDF version of Voided Check or Bank Letter :
            </div>
            <input type='file' accept="application/pdf" onChange={(e) => setVoidedCheckFile(e.target.files)} className='External-Form-File-Upload'/>
        </div>
    )
};

// W9 SECTION
const W9Section = ({w9Active, downloadBlankW9, setFinishedW9}) => {
    return(
        <div className='External-Vendor-Information'>
            {   w9Active &&
                <>
                    <div className='External-Vendor-Type-Title External-Vendor-Bold'>
                        Please download the blank W9, fill it out, and attach the finished copy below.
                    </div>
                    <button onClick={() => downloadBlankW9()}>Click Here to Download Blank W9</button>
                </>
            }
            {   !w9Active &&
                <>
                    <div className='External-Vendor-Thick-Spacer'/>
                    <div className='External-Vendor-Type-Title'>
                        W9
                    </div>
                </>
            }
            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>
            PDF version of completed W9:
            </div>
            <input type='file' accept="application/pdf" onChange={(e) => setFinishedW9(e.target.files)} className='External-Form-File-Upload'/>
        </div>
    )
};

// CONDITIONS SECTION
const ConditionsSection = ({termsAccepted,setTermsAccepted,setOfficerName,officerName,officerNameComplete,setOfficerTitle,officerTitle,
    officerTitleComplete,setSignature,signatureComplete,signature}) => {
    const conditionString = 'I certify that I am authorized to provide this information, and that the information on this form is correct to the best of my knowledge. I understand that if payment is erroneously made to the account identified above, Cornerstone reserves the right to reverse the transfer. If Vendor provides inaccurate payment information, Vendor agrees to indemnify and hold harmless Cornerstone from any damages or costs associated with providing incorrect information in this Authorization. I acknowledge that it is Vendor’s responsibility to notify Cornerstone immediately if it believes there is a discrepancy between the amount deposited to its bank account and the amount of the invoice(s) paid. I understand that it is Vendor’s responsibility to notify Cornerstone immediately of any changes in the financial institution(s) or account(s) identified above. I understand that this Authorization will remain in full force and effect until Cornerstone has received written notification requesting a change or cancellation and has had a reasonable opportunity to act on the change or cancellation. I hereby authorize Cornerstone to electronically deposit payments to the bank account designated above as payment under Vendor’s agreement(s) with Cornerstone.'
    const confirmationString = 'Click here to indicate that you have read and agree to the terms above.'
    const disclaimerString = 'Please note that vendor onboarding may take up to 5-7 business days, as we are required to verify all vendor information — including banking details — We utilize Truist Verify for automated verification, but we may contact you by phone before setup is complete.”'
    const [liveTimestamp, setLiveTimestamp] = useState(new Date());
    const [clientIp, setClientIp] = useState('Detecting...');

    useEffect(() => {
        const timer = setInterval(() => {
            setLiveTimestamp(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadIpAddress = async () => {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                if (isMounted) {
                    setClientIp(data.ip || 'Unavailable');
                }
            } catch (error) {
                if (isMounted) {
                    setClientIp('Unavailable');
                }
            }
        };

        loadIpAddress();

        return () => {
            isMounted = false;
        };
    }, []);

    const signedTimestamp = liveTimestamp.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Local';
    const signingReason = 'vendor application for review';
    const signerDisplayName = signature || officerName || 'Pending Signature';
    const signatureTraceId = useState(() => {
        const seed = Math.random().toString(16).replace('0.', '').slice(0, 20).toUpperCase();
        return `SIG-${seed}`;
    })[0];

    return(
        <div className='External-Form-Conditions'>
            <div className='External-Form-Conditions-Text'>
                {disclaimerString}
            </div>
            <div className='External-Form-Conditions-Text'>
                {conditionString}
            </div>
            <div className='External-Form-Conditions-Accept'>
                <input type='checkbox' className='External-Form-Conditions-Accept-Input' onClick={(e) => setTermsAccepted(e.target.checked)}/>
                <div className='External-Form-Conditions-Accept-Text'>
                    {confirmationString}
                </div>
            </div>
            <div className='External-Form-Conditions-Information'>
                <TextInput title={`Officer's Name`} setTo={setOfficerName} complete={officerNameComplete} width={300} required={true} initializedValue={officerName}/>
                <TextInput title={`Officer's Title`} setTo={setOfficerTitle} complete={officerTitleComplete} width={300} required={true} initializedValue={officerTitle}/>
                <div className='External-Vendor-Signature-Row'>
                    <div className='External-Vendor-Signature-Section'>
                        <SignatureInput title={`Officer's Signature`} setTo={setSignature} complete={signatureComplete} width={400} initializedValue={signature}/>
                        <div className='External-Vendor-Signature-Text'>
                            Typed name is considered a valid/legal signature
                        </div>
                    </div>
                    <div className='External-Form-Signature-Audit-Compact'>
                        <div className='External-Form-Signature-Audit-Ip'>IP Address: {clientIp}</div>
                        <div className='External-Form-Signature-Audit-Script'>{signerDisplayName}</div>
                        <div className='External-Form-Signature-Audit-Line'>Signer Name: {signerDisplayName}</div>
                        <div className='External-Form-Signature-Audit-Line'>Signing Reason: {signingReason}</div>
                        <div className='External-Form-Signature-Audit-Line'>Signing Time: {signedTimestamp} {timezone}</div>
                        <div className='External-Form-Signature-Audit-Line'>Trace ID: {signatureTraceId}</div>
                    </div>
                </div>
            </div>
            
            {   !termsAccepted &&
            <div  className='External-Vendor-Type-Error'>
                Accept Terms to continue.
            </div>
            }

            {   !officerNameComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a valid Office Name to continue.
            </div>
            }
            {   !officerTitleComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a valid Office Title to continue.
            </div>
            }
            {   !signatureComplete &&
            <div  className='External-Vendor-Type-Error'>
                Enter a valid Signature to continue.
            </div>
            }

        </div>
    )
};

// FORM SUBMISSION - - - - - - - -
const FormSubmissionWindow = ({voidedCheckId,voidedCheckShown,coiId,coiShown,w9Id,intWireShown,intWireId,finalizedSubmitting, w9Updated, voidedCheckUpdated, coiUpdated, intWireUpdated, businessClassificationShown, businessClassificationId, businessClassificationUpdated}) => {
    // FILES SECTION HELPER FUNCTION
    const FileSection = ({loading, title, seperator=false}) => {
        return(
            <div className='External-Form-Submission-Section'>
                <div className='External-Form-Submission-File-Group'>
                    <div className='External-Form-Submission-Status'>
                        {   loading &&
                            <LoadingSpinner size={60}/>
                        }     
                        {   !loading &&
                            <HiBadgeCheck className='External-Form-Accepted' />
                        }
                    </div>
                    <div className='External-Form-Submission-Title'>
                        {title}
                    </div>
                </div>
                {   seperator &&
                    <FaDotCircle className='External-Form-Submission-Seperator'/>
                }
            </div>
        )
    };
    
    return(
        <div className='External-Form-Submission-Window'>
            {   voidedCheckUpdated && 
                <FileSection loading={!voidedCheckId} title={'Submitting Voided Check'} seperator={true}/>
            }
            {   coiUpdated &&
                <FileSection loading={!coiId} title={'Submitting COI'} seperator={true}/>
            }
            {   intWireUpdated &&
                <FileSection loading={!intWireId} title={'Submitting International Wire Instructions'} seperator={true}/>
            }

            {   w9Updated &&
                <FileSection loading={!w9Id} title={'Submitting W9'} seperator={true}/>
            }

            {   businessClassificationUpdated &&
                <FileSection loading={!businessClassificationId} title={'Submitting Proof of Business Classification'} seperator={true}/>
            }

            <FileSection loading={!finalizedSubmitting} title={'Submitting Vendor Request'}/>

            {   finalizedSubmitting &&
                <div className='External-Form-Submission-Success'>
                    We have received your information. Thank you!
                </div>
            }

        </div>
    )
};

// REJECTION - - - - - - - - - - - 
const RejectionHeader = ({rejectionRecord}) => {
    
    return(
        <div className='Rejection-Header'>
            <div className='Rejection-Header-Title'>
                Your request has been rejected for the following reasons:
            </div>
            <div className='Rejection-Header-Text'>
                {rejectionRecord.text}
            </div>
            <div className='Rejection-Header-Instructions'>
                Please update below and resubmit.
            </div>
        </div>
    )
};

// PRIMARY FUNCTION - - - - - - - - -
const NewVendor = () => {
    const { email, vendorNumber, sessionId } = useParams();
    const [ notificationEmail, setNotificationEmail ] = useState(email);
    const [ vendorRecord, setVendorRecord ] = useState();
    
    useEffect(() => {
        setNotificationEmail(email);
    },[email]);

    useEffect(() => {
        if(sessionId && vendorNumber) getVendorRecord(sessionId, vendorNumber, setVendorRecord);
    },[vendorNumber, sessionId]);

    useEffect(() => {
        getEncryptionKey(setEncryptionKey, setEncryptionKeyError);
    },[]);

    // DEFAULTS
    const formEmail = 'For questions or support, please email: ACH@cornerstoneinc.com';
    const vendorTypeOptions = [ 'Attorney', 'Government','Rent','Subcontractor','Supplier','Utilities Provider','Labor Union', 'Temp Labor', 'Sponsor'];
    const paymentTypes = ['ACH', 'Purchasing Card', 'International Wire'];
    const paymentTermNamesOptions = ['Due On Receipt','Net 10 Days', 'Net 15 Days', 'Net 30 Days', 'Net 45 Days', 'Net 60 Days', '1st of the Month', '10th of the Following Month', '1st of the Following Month','1% Discount 10 Days, Net 30','1% Discount 15 Days, Net 30','2% Discount 30 days','2% Discount 10 Days, Net 30','2% Discount 15 Days, Net 30']
    const paymentTermsObject = {
        'Due On Receipt' : 'DOR',
        'Net 10 Days': 'NET10',
        'Net 15 Days': 'NET15',
        'Net 30 Days': 'NET30',
        'Net 45 Days': 'NET45',
        'Net 60 Days': 'NET60',
        '1st of the Month': '1STMNTH',
        '10th of the Following Month': 'NET10THPRO',
        '1st of the Following Month': 'NET1STPROX',
        '1% Discount 10 Days, Net 30': '1P10DAYN30',
        '1% Discount 15 Days, Net 30': '1P15DAYN30',
        '2% Discount 30 days': '2DISC30DAY',
        '2% Discount 10 Days, Net 30': '2P10DAYN30',
        '2% Discount 15 Days, Net 30': '2P15DAYN30'
    };

    const invoiceCurrencyOptions = ['USD', 'CAD'];
    const businessClassifications = ['MBE(State)','MBE(Fed)','WBE','MWBE','VBE','DVBE','SDVBE','LGBTBE','WOSB','EDWOSB','VOSB','SDVOSB','HUBZone','8(a)','DBE','CAN'];
    const params = useSearchParams(); 

    // FORM TYPE STATE
    const [ formType, setFormType ] = useState('New');
    const [ typeActive, setTypeActive ] = useState(true);
    const [ typeComplete, setTypeComplete ] = useState(true);

    // VENDOR INFORMATION STATE
    const [ vendorInformationActive, setVendorInformationActive ] = useState(false);
    const [ vendorInformationComplete, setVendorInformationComplete ] = useState(false);
    const [ fedEinSSn, setFedEinSSn ] = useState('');
    const [ fedEinSSnComplete, setFedEinSSnComplete ] = useState(false);
    const [ legalName, setLegalName ] = useState('');
    const [ legalNameComplete, setLegalNameComplete ] = useState(false);
    const [ businessName, setBusinessName ] = useState('');
    const [ businessNameComplete, setBusinessNameComplete ] = useState(false);
    const [ street, setStreet ] = useState('');
    const [ street2, setStreet2 ] = useState('');
    const [ streetComplete, setStreetComplete ] = useState(false);
    const [ city, setCity ] = useState('');
    const [ cityComplete, setCityComplete ] = useState(false);
    const [ state, setState ] = useState('');
    const [ stateComplete, setStateComplete ] = useState(false);
    const [ zip, setZip ] = useState('');
    const [ zipComplete, setZipComplete ] = useState(false);
    const [ country, setCountry ] = useState('USA');

    // CONTACT STATE
    const [ contactInformationShown, setContactInformationShown ] = useState(false);
    const [ contactInformationActive, setContactInformationActive ] = useState(false);
    const [ primaryContactFirstName, setPrimaryContactFirstName ] = useState('');
    const [ primaryContactLastName, setPrimaryContactLastName ] = useState('');
    const [ primaryContactFirstNameComplete, setPrimaryContactFirstNameComplete ] = useState(false);
    const [ primaryContactLastNameComplete, setPrimaryContactLastNameComplete ] = useState(false);
    const [ primaryContactTitle, setPrimaryContactTitle ] = useState('');
    const [ primaryContactNumber, setPrimaryContactNumber ] = useState('');
    const [ primaryContactNumberComplete, setPrimaryContactNumberComplete ] = useState(false);
    const [ primaryContactNumberExtension, setPrimaryContactNumberExtension] = useState('');
    const [ primaryContactEmail, setPrimaryContactEmail ] = useState('');
    const [ primaryContactEmailComplete, setPrimaryContactEmailComplete ] = useState(false);
    

    // REMIT STATE
    const [ remitInformationShown, setRemitInformationShown ] = useState(false);
    const [ remitInformationActive, setRemitInformationActive ] = useState(false);
    const [ remitComplete, setRemitComplete ] = useState(false);
    const [ remitFirstName1, setRemitFirstName1 ] = useState('');
    const [ remitLastName1, setRemitLastName1 ] = useState('');
    const [ remitFirstName1Complete, setRemitFirstName1Complete ] = useState(false);
    const [ remitLastName1Complete, setRemitLastName1Complete ] = useState(false);
    const [ remitTitle1, setRemitTitle1 ] = useState('');
    const [ remitNumber1, setRemitNumber1 ] = useState('');
    const [ remitNumber1Complete, setRemitNumber1Complete ] = useState(false);
    const [ remitNumberExtension1, setRemitNumberExtension1] = useState('');
    const [ remitEmail1, setRemitEmail1 ] = useState('');
    const [ remitEmail1Complete, setRemitEmail1Complete ] = useState(false);
    const [ remitContact2, setRemitContact2 ] = useState(false);
    const [ remitFirstName2, setRemitFirstName2 ] = useState('');
    const [ remitLastName2, setRemitLastName2 ] = useState('');
    const [ remitFirstName2Complete, setRemitFirstName2Complete ] = useState(false);
    const [ remitLastName2Complete, setRemitLastName2Complete ] = useState(false);
    const [ remitTitle2, setRemitTitle2 ] = useState('');
    const [ remitNumber2, setRemitNumber2 ] = useState('');
    const [ remitNumber2Complete, setRemitNumber2Complete ] = useState(false);
    const [ remitNumberExtension2, setRemitNumberExtension2] = useState('');
    const [ remitEmail2, setRemitEmail2 ] = useState('');
    const [ remitEmail2Complete, setRemitEmail2Complete ] = useState(false);

    // PAYMENT STATE
    const [ paymentInformationShown, setPaymentInformationShown ] = useState(false);
    const [ paymentInformationActive, setPaymentInformationActive ] = useState(false);
    const [ vendorTypeSelection, setVendorTypeSelection ] = useState('');
    const [ vendorTypeSelectionComplete, setVendorTypeSelectionComplete ] = useState(false);
    const [ paymentMethod, setPaymentMethod ] = useState('');
    const [ paymentMethodComplete, setPaymentMethodComplete ] = useState(false);
    const [ classificationList, setClassificationList ] = useState([]);
    const [ paymentTerms, setPaymentTerms] = useState('');
    const [ paymentTermsComplete, setPaymentTermsComplete] = useState('');
    const [ paymentTermNames, setPaymentTermNames] = useState('');
    const [ paymentTermNamesComplete, setPaymentTermNamesComplete] = useState(false);
    const [ customTermsShown, setCustomTermsShown ] = useState(false);
    const [ customTerms, setCustomTerms ] = useState('');
    const [ invoiceCurrency, setInvoiceCurrency ] = useState('');
    const [ invoiceCurrencyComplete, setInvoiceCurrencyComplete ] = useState(false);


    // ACH STATE
    const [ achShown, setAchShown ] = useState(false);
    const [ achActive, setAchActive ] = useState(false);
    const [ achComplete, setAchComplete ] = useState(false);
    const [ bankName, setBankName ] = useState('');
    const [ bankNameComplete, setBankNameComplete ] = useState(false);
    const [ bankContactFirstName, setBankContactFirstName ] = useState('');
    const [ bankContactLastName, setBankContactLastName ] = useState('');
    const [ bankContactFirstNameComplete, setBankContactFirstNameComplete ] = useState(false);
    const [ bankContactLastNameComplete, setBankContactLastNameComplete ] = useState(false);
    const [ bankStreet, setBankStreet ] = useState('');
    const [ bankStreet2, setBankStreet2 ] = useState('');
    const [ bankStreetComplete, setBankStreetComplete ] = useState(false);
    const [ bankCity, setBankCity ] = useState('');
    const [ bankCityComplete, setBankCityComplete ] = useState('');
    const [ bankState, setBankState ] = useState('');
    const [ bankStateComplete, setBankStateComplete ] = useState(false);
    const [ bankZip, setBankZip ] = useState('');
    const [ bankZipComplete, setBankZipComplete ] = useState(false);
    const [ bankCountry, setBankCountry ] = useState('USA');
    const [ bankCountryComplete, setBankCountryComplete ] = useState(false);
    const [ bankTelephone, setBankTelephone ] = useState('');
    const [ bankTelephoneComplete, setBankTelephoneComplete ] = useState(false);
    const [ bankContactEmail, setBankContactEmail ] = useState('');
    const [ bankContactEmailComplete, setBankContactEmailComplete ] = useState(false);
    const [ bankVendorStreet, setBankVendorStreet ] = useState('');
    const [ bankVendorStreet2, setBankVendorStreet2 ] = useState('');
    const [ bankVendorStreetComplete, setBankVendorStreetComplete ] = useState(false);
    const [ bankVendorCity, setBankVendorCity ] = useState('');
    const [ bankVendorCityComplete, setBankVendorCityComplete ] = useState(false);
    const [ bankVendorState, setBankVendorState ] = useState('');
    const [ bankVendorStateComplete, setBankVendorStateComplete ] = useState(false);
    const [ bankVendorZip, setBankVendorZip ] = useState('');
    const [ bankVendorZipComplete, setBankVendorZipComplete ] = useState(false);
    const [ bankVendorCountry, setBankVendorCountry ] = useState('USA');
    const [ bankAccountName, setBankAccountName ] = useState('');
    const [ bankAccountNameComplete, setBankAccountNameComplete ] = useState(false);
    const [ bankAccountNumber, setBankAccountNumber ] = useState('');
    const [ bankAccountNumberComplete, setBankAccountNumberComplete ] = useState(false);
    const [ bankRoutingNumber, setBankRoutingNumber ] = useState('');
    const [ bankRoutingNumberComplete, setBankRoutingNumberComplete ] = useState(false);
    const [ bankAccountSelection, setBankAccountSelection ] = useState('Checking');
    const [ bankAccountSelectionComplete, setBankAccountSelectionComplete ] = useState(false);

    // VOIDED CHECK STATE
    const [ voidedCheckShown, setVoidedCheckShown ] = useState(false);
    const [ voidedCheckActive, setVoidedCheckActive ] = useState(false);
    const [ voidedCheckFile, setVoidedCheckFile ] = useState();
    const [ voidedCheckId, setVoidedCheckId ] = useState();
    const [ voidedCheckComplete, setVoidedCheckComplete ] = useState(false);
    const [ voidedCheckError, setVoidedCheckError ] = useState('');

    // COI STATE
    const [ coiFile, setCoiFile ] = useState();
    const [ coiShown, setCoiShown ] = useState(false);
    const [ coiActive, setCoiActive] = useState(false);
    const [ coiId, setCoiId] = useState();
    const [ coiComplete, setCoiComplete ] = useState(false);
    const [ coiError, setCoiError ] = useState();

    // W9 STATE
    const [ w9Shown, setW9Shown ] = useState(false);
    const [ w9Active, setW9Active ] = useState(false);
    const [ finishedW9, setFinishedW9 ] = useState();
    const [ w9Id, setW9Id ] = useState();
    const [ w9Complete, setW9Complete ] = useState(false);
    const [ w9Error, setW9Error ] = useState('');

    // INTERNATIONAL WIRE STATE
    const [ intWireShown, setIntWireShown ] = useState(false);
    const [ intWireActive, setIntWireActive ] = useState(false);
    const [ intWire, setIntWire ] = useState();
    const [ intWireId, setIntWireId ] = useState();
    const [ intWireComplete, setIntWireComplete ] = useState(false);
    const [ intWireError, setIntWireError ] = useState('');

    
    // BUSINESS CLASSIFICATION STATE
    const [ businessClassificationShown, setBusinessClassificationShown ] = useState(false);
    const [ businessClassificationActive, setBusinessClassificationActive ] = useState(false);
    const [ businessClassification, setBusinessClassification ] = useState();
    const [ businessClassificationId, setBusinessClassificationId ] = useState();
    const [ businessClassificationComplete, setBusinessClassificationComplete ] = useState(false);
    const [ businessClassificationError, setBusinessClassificationError ] = useState('');

    // CONDITIONS STATE
    const [ conditionsShown, setConditionsShown ] = useState(false);
    const [ conditionsComplete, setConditionsComplete ] = useState(false);
    const [ termsAccepted, setTermsAccepted ] = useState(false);
    const [ officerName, setOfficerName ] = useState('');
    const [ officerNameComplete, setOfficerNameComplete ] = useState(false);
    const [ officerTitle, setOfficerTitle ] = useState('');
    const [ officerTitleComplete, setOfficerTitleComplete ] = useState(false);
    const [ signature, setSignature ] = useState('');
    const [ signatureComplete, setSignatureComplete ] = useState(false);

    // SUBMITTING STATE
    const [ submitting, setSubmitting ] = useState(false);
    const [ finalizedSubmitting, setFinalizedSubmitted ] = useState(false);
    const [ vendorRecordError, setVendorRecordError ] = useState('');

    // REJECTION STATES
    const [ formTypeShown, setFormTypeShown ] = useState(false);
    const [ vendorInformationShown, setVendorInformationShown ] = useState(false);

    const [ rejectionRecord, setRejectionRecord ] = useState();

    const [ w9Updated, setW9Updated ] = useState(false);
    const [ coiUpdated, setCoiUpdated ] = useState(false);
    const [ intWireUpdated, setIntWireUpdated ] = useState(false);
    const [ voidedCheckUpdated, setVoidedCheckUpdated ] = useState(false);
    const [ businessClassificationUpdated, setBusinessClassificationUpdated ] = useState(false);
    const [ submittingRecord, setSubmittingRecord ] = useState(false);
    const [ draftHydrated, setDraftHydrated ] = useState(false);
    const [ attachmentValidationError, setAttachmentValidationError ] = useState('');
    const [ encryptionKey, setEncryptionKey ] = useState(null);
    const [ encryptionKeyError, setEncryptionKeyError ] = useState('');

    const draftStorageKey = `newVendorDraft:${sessionId || 'nosession'}:${vendorNumber || 'novendor'}:${email || 'noemail'}`;

    const buildDraftPayload = () => ({
        formType,
        fedEinSSn,
        legalName,
        businessName,
        street,
        street2,
        city,
        state,
        zip,
        country,
        primaryContactFirstName,
        primaryContactLastName,
        primaryContactTitle,
        primaryContactNumber,
        primaryContactNumberExtension,
        primaryContactEmail,
        remitFirstName1,
        remitLastName1,
        remitTitle1,
        remitNumber1,
        remitNumberExtension1,
        remitEmail1,
        remitContact2,
        remitFirstName2,
        remitLastName2,
        remitTitle2,
        remitNumber2,
        remitNumberExtension2,
        remitEmail2,
        vendorTypeSelection,
        paymentMethod,
        classificationList,
        paymentTerms,
        paymentTermNames,
        customTerms,
        invoiceCurrency,
        bankName,
        bankContactFirstName,
        bankContactLastName,
        bankStreet,
        bankStreet2,
        bankCity,
        bankState,
        bankZip,
        bankCountry,
        bankTelephone,
        bankContactEmail,
        bankVendorStreet,
        bankVendorStreet2,
        bankVendorCity,
        bankVendorState,
        bankVendorZip,
        bankVendorCountry,
        bankAccountName,
        bankAccountNumber,
        bankRoutingNumber,
        bankAccountSelection,
        officerName,
        officerTitle,
        signature,
        termsAccepted,
    });

    const hydrateDraft = (draft) => {
        if (!draft) return;

        if (typeof draft.formType === 'string') setFormType(draft.formType);
        if (typeof draft.fedEinSSn === 'string') setFedEinSSn(draft.fedEinSSn);
        if (typeof draft.legalName === 'string') setLegalName(draft.legalName);
        if (typeof draft.businessName === 'string') setBusinessName(draft.businessName);
        if (typeof draft.street === 'string') setStreet(draft.street);
        if (typeof draft.street2 === 'string') setStreet2(draft.street2);
        if (typeof draft.city === 'string') setCity(draft.city);
        if (typeof draft.state === 'string') setState(draft.state);
        if (typeof draft.zip === 'string') setZip(draft.zip);
        if (typeof draft.country === 'string') setCountry(draft.country);

        if (typeof draft.primaryContactFirstName === 'string') setPrimaryContactFirstName(draft.primaryContactFirstName);
        if (typeof draft.primaryContactLastName === 'string') setPrimaryContactLastName(draft.primaryContactLastName);
        if (typeof draft.primaryContactTitle === 'string') setPrimaryContactTitle(draft.primaryContactTitle);
        if (typeof draft.primaryContactNumber === 'string') setPrimaryContactNumber(draft.primaryContactNumber);
        if (typeof draft.primaryContactNumberExtension === 'string') setPrimaryContactNumberExtension(draft.primaryContactNumberExtension);
        if (typeof draft.primaryContactEmail === 'string') setPrimaryContactEmail(draft.primaryContactEmail);

        if (typeof draft.remitFirstName1 === 'string') setRemitFirstName1(draft.remitFirstName1);
        if (typeof draft.remitLastName1 === 'string') setRemitLastName1(draft.remitLastName1);
        if (typeof draft.remitTitle1 === 'string') setRemitTitle1(draft.remitTitle1);
        if (typeof draft.remitNumber1 === 'string') setRemitNumber1(draft.remitNumber1);
        if (typeof draft.remitNumberExtension1 === 'string') setRemitNumberExtension1(draft.remitNumberExtension1);
        if (typeof draft.remitEmail1 === 'string') setRemitEmail1(draft.remitEmail1);
        if (typeof draft.remitContact2 === 'boolean') setRemitContact2(draft.remitContact2);
        if (typeof draft.remitFirstName2 === 'string') setRemitFirstName2(draft.remitFirstName2);
        if (typeof draft.remitLastName2 === 'string') setRemitLastName2(draft.remitLastName2);
        if (typeof draft.remitTitle2 === 'string') setRemitTitle2(draft.remitTitle2);
        if (typeof draft.remitNumber2 === 'string') setRemitNumber2(draft.remitNumber2);
        if (typeof draft.remitNumberExtension2 === 'string') setRemitNumberExtension2(draft.remitNumberExtension2);
        if (typeof draft.remitEmail2 === 'string') setRemitEmail2(draft.remitEmail2);

        if (typeof draft.vendorTypeSelection === 'string') setVendorTypeSelection(draft.vendorTypeSelection);
        if (typeof draft.paymentMethod === 'string') setPaymentMethod(draft.paymentMethod);
        if (Array.isArray(draft.classificationList)) setClassificationList(draft.classificationList);
        if (typeof draft.paymentTerms === 'string') setPaymentTerms(draft.paymentTerms);
        if (typeof draft.paymentTermNames === 'string') setPaymentTermNames(draft.paymentTermNames);
        if (typeof draft.customTerms === 'string') setCustomTerms(draft.customTerms);
        if (typeof draft.invoiceCurrency === 'string') setInvoiceCurrency(draft.invoiceCurrency);

        if (typeof draft.bankName === 'string') setBankName(draft.bankName);
        if (typeof draft.bankContactFirstName === 'string') setBankContactFirstName(draft.bankContactFirstName);
        if (typeof draft.bankContactLastName === 'string') setBankContactLastName(draft.bankContactLastName);
        if (typeof draft.bankStreet === 'string') setBankStreet(draft.bankStreet);
        if (typeof draft.bankStreet2 === 'string') setBankStreet2(draft.bankStreet2);
        if (typeof draft.bankCity === 'string') setBankCity(draft.bankCity);
        if (typeof draft.bankState === 'string') setBankState(draft.bankState);
        if (typeof draft.bankZip === 'string') setBankZip(draft.bankZip);
        if (typeof draft.bankCountry === 'string') setBankCountry(draft.bankCountry);
        if (typeof draft.bankTelephone === 'string') setBankTelephone(draft.bankTelephone);
        if (typeof draft.bankContactEmail === 'string') setBankContactEmail(draft.bankContactEmail);
        if (typeof draft.bankVendorStreet === 'string') setBankVendorStreet(draft.bankVendorStreet);
        if (typeof draft.bankVendorStreet2 === 'string') setBankVendorStreet2(draft.bankVendorStreet2);
        if (typeof draft.bankVendorCity === 'string') setBankVendorCity(draft.bankVendorCity);
        if (typeof draft.bankVendorState === 'string') setBankVendorState(draft.bankVendorState);
        if (typeof draft.bankVendorZip === 'string') setBankVendorZip(draft.bankVendorZip);
        if (typeof draft.bankVendorCountry === 'string') setBankVendorCountry(draft.bankVendorCountry);
        if (typeof draft.bankAccountName === 'string') setBankAccountName(draft.bankAccountName);
        if (typeof draft.bankAccountNumber === 'string') setBankAccountNumber(draft.bankAccountNumber);
        if (typeof draft.bankRoutingNumber === 'string') setBankRoutingNumber(draft.bankRoutingNumber);
        if (typeof draft.bankAccountSelection === 'string') setBankAccountSelection(draft.bankAccountSelection);

        if (typeof draft.officerName === 'string') setOfficerName(draft.officerName);
        if (typeof draft.officerTitle === 'string') setOfficerTitle(draft.officerTitle);
        if (typeof draft.signature === 'string') setSignature(draft.signature);
        if (typeof draft.termsAccepted === 'boolean') setTermsAccepted(draft.termsAccepted);
    };


    // REJECTIONS - - - - - - - - - - -
    const markFieldsComplete = (vendorProfile) => {
        setTypeComplete(true);
        setFedEinSSnComplete(true);
        setLegalNameComplete(true);
        setBusinessNameComplete(true);
        setStreetComplete(true);
        setCityComplete(true);
        setStateComplete(true);
        setZipComplete(true);
        setPrimaryContactFirstNameComplete(true);
        setPrimaryContactLastNameComplete(true);
        setPrimaryContactNumberComplete(true);
        setPrimaryContactEmailComplete(true);
        setRemitFirstName1Complete(true);
        setRemitLastName1Complete(true);
        setRemitNumber1Complete(true);
        setRemitEmail1Complete(true);
        if(vendorProfile.remitContact2 && vendorProfile.remitContact2.firstName){
            setRemitFirstName2Complete(true);
            setRemitLastName2Complete(true);
            setRemitNumber2Complete(true);
            setRemitEmail2Complete(true);
        };
        setVendorTypeSelectionComplete(true);
        setPaymentMethodComplete(true);
        setPaymentTermsComplete(true);
        setPaymentTermNamesComplete(true);
        setInvoiceCurrencyComplete(true);
        if(vendorProfile && vendorProfile.bankAccount){
            setBankNameComplete(true);
            setBankContactFirstNameComplete(true);
            setBankContactLastNameComplete(true);
            setBankStreetComplete(true);
            setBankCityComplete(true);
            setBankStateComplete(true);
            setBankZipComplete(true);
            setBankCountryComplete(true);
            setBankTelephoneComplete(true);
            setBankContactEmailComplete(true);
            setBankVendorStreetComplete(true);
            setBankVendorCityComplete(true);
            setBankVendorStateComplete(true);
            setBankVendorZipComplete(true);
            setBankAccountNameComplete(true);
            setBankAccountNumberComplete(true);
            setBankRoutingNumberComplete(true);
            setBankAccountSelectionComplete(true);
        };
        setOfficerNameComplete(true);
        setOfficerTitleComplete(true);
    };

    // INITIALIZE REJECTED VENDOR RECORD
    const initializeVendorRecord = (vendorProfile) => {
        // Form Type
        setFormType(vendorProfile.formType);
        // Vendor Information
        setFedEinSSn(vendorProfile.einSsn);
        setLegalName(vendorProfile.legalName);
        setBusinessName(vendorProfile.businessName);
        setStreet(vendorProfile.businessAddress.street);
        setStreet2(vendorProfile.businessAddress.street2);
        setCity(vendorProfile.businessAddress.city);
        setState(vendorProfile.businessAddress.state);
        setZip(vendorProfile.businessAddress.zip);
        setCountry(vendorProfile.businessAddress.country);
        // Contact Information
        setPrimaryContactFirstName(vendorProfile.primaryContact.firstName);
        setPrimaryContactLastName(vendorProfile.primaryContact.lastName);
        setPrimaryContactTitle(vendorProfile.primaryContact.title);
        setPrimaryContactNumber(vendorProfile.primaryContact.number);
        setPrimaryContactNumberExtension(vendorProfile.primaryContact.extension);
        setPrimaryContactEmail(vendorProfile.primaryContact.email);
        
        // Remit Information
        setRemitFirstName1(vendorProfile.remitContact1.firstName);
        setRemitLastName1(vendorProfile.remitContact1.lastName);
        setRemitTitle1(vendorProfile.remitContact1.title);
        setRemitNumber1(vendorProfile.remitContact1.number);
        setRemitNumberExtension1(vendorProfile.remitContact1.extension);
        setRemitEmail1(vendorProfile.remitContact1.email);

        if(vendorProfile.remitContact2){
            setRemitFirstName2(vendorProfile.remitContact2.firstName);
            setRemitLastName2(vendorProfile.remitContact2.lastName);
            setRemitTitle2(vendorProfile.remitContact2.title);
            setRemitNumber2(vendorProfile.remitContact2.number);
            setRemitNumberExtension2(vendorProfile.remitContact2.extension);
            setRemitEmail2(vendorProfile.remitContact2.email);
        };
        // Payment Information
        setVendorTypeSelection(vendorProfile.vendorType);
        setPaymentMethod(vendorProfile.paymentMethod);
        setPaymentTerms(vendorProfile.paymentTerms);
        setPaymentTermNames(vendorProfile.paymentTermsName);
        setInvoiceCurrency(vendorProfile.currency);
        setCustomTermsShown(vendorProfile.customTerms ? true : false);
        setCustomTerms(vendorProfile.customTerms ? vendorProfile.customTerms : '');
        
        setClassificationList(vendorProfile.classificationList);
        // ACH
        if(vendorProfile.bankAccount){
            setBankName(vendorProfile.bankAccount.name);
            setBankContactFirstName(vendorProfile.bankAccount.contact.firstName);
            setBankContactLastName(vendorProfile.bankAccount.contact.lastName);
            setBankStreet(vendorProfile.bankAccount.address.street);
            setBankStreet2(vendorProfile.bankAccount.address.street2);
            setBankCity(vendorProfile.bankAccount.address.city);
            setBankState(vendorProfile.bankAccount.address.state);
            setBankZip(vendorProfile.bankAccount.address.zip);
            setBankCountry(vendorProfile.bankAccount.address.country);
            setBankTelephone(vendorProfile.bankAccount.contact.number);
            setBankContactEmail(vendorProfile.bankAccount.contact.email);
            setBankVendorStreet(vendorProfile.bankAccount.vendorAddress?.street || '');
            setBankVendorStreet2(vendorProfile.bankAccount.vendorAddress?.street2 || '');
            setBankVendorCity(vendorProfile.bankAccount.vendorAddress?.city || '');
            setBankVendorState(vendorProfile.bankAccount.vendorAddress?.state || '');
            setBankVendorZip(vendorProfile.bankAccount.vendorAddress?.zip || '');
            setBankVendorCountry(vendorProfile.bankAccount.vendorAddress?.country || 'USA');
            setBankAccountName(vendorProfile.bankAccount.accountName);
            setBankAccountNumber(vendorProfile.bankAccount.accountNumber);
            setBankRoutingNumber(vendorProfile.bankAccount.routingNumber);
            setBankAccountSelection(vendorProfile.bankAccount.accountType);
        };
        setOfficerName(vendorProfile.signerName);
        setOfficerTitle(vendorProfile.signerTitle);
    };

    // INITIALIZE SECTIONS SHOWN
    const initializeForm = (vendorProfile) => {
            console.log('INITIALIZE FORM', vendorProfile);
            setVendorInformationActive(false);
            setVendorInformationShown(true);
            setContactInformationActive(false);
            setContactInformationShown(true);
            setRemitInformationActive(false);
            setRemitComplete(true);
            setRemitInformationShown(true);
            setPaymentInformationActive(false);
            setPaymentInformationShown(true);
            if(vendorProfile.bankAccount) {
                setAchActive(false);
                setAchShown(true);
            };
            if(vendorProfile.vendorType === 'Subcontractor') {
                setCoiActive(false);
                setCoiShown(true);
            };
            setW9Active(false);
            setW9Shown(true);
            if(vendorProfile.paymentMethod === 'ACH') {
                setVoidedCheckActive(false);
                setVoidedCheckShown(true);
            };
            if(vendorProfile.paymentMethod === 'International Wire') {
                setIntWireActive(false);
                setIntWireShown(true);
            };
            if(vendorProfile.classificationList && vendorProfile.classificationList.length > 0) {
                setBusinessClassificationActive(false);
                setBusinessClassificationShown(true);
            };
    };

    useEffect(() => {   // CALL TO INITIALIZE IF REJECTION RECORD FOUND
        if(rejectionRecord){
            initializeVendorRecord(rejectionRecord.vendorProfile);
            markFieldsComplete(rejectionRecord.vendorProfile);
            initializeForm(rejectionRecord.vendorProfile);
        };
    },[rejectionRecord]);

    useEffect(() => {
        if (draftHydrated) return;
        if (typeof window === 'undefined') return;

        try {
            const rawDraft = window.localStorage.getItem(draftStorageKey);
            if (rawDraft) {
                hydrateDraft(JSON.parse(rawDraft));
            }
        }
        catch (e) {
            console.error('Unable to load vendor draft', e);
        }
        finally {
            setDraftHydrated(true);
        }
    }, [draftStorageKey, draftHydrated, rejectionRecord]);

    useEffect(() => { // DETERMINES IF THIS IS A REJECTION OR NOT - CALLS TO SET RECORD
        const searchParams = params[0];
        if(searchParams.get("sessionId")) grabRejectionRecord(searchParams.get("sessionId"),searchParams.get("rejectionId"),setRejectionRecord);
        else setRejectionRecord(null);
    },[]);
    //PROPS
    const rejectionProps = {
        rejectionRecord: rejectionRecord,
    };

// FORM TYPE
    const handleFormTypeSelection = (selection) => {
        setFormType(selection);
    };
    useEffect(() => {
        if(formType) {
            setTypeActive(false);
            setTypeComplete(true);
            setVendorInformationActive(true);
        }
        else{
            setTypeActive(true);
            setTypeComplete(false);
            setVendorInformationActive(false);
        }
    },[formType]);

    // *TRANSITION* - - - - VENDOR <-> CONTACTS
    const transitionFromVendor = (valid) => {
        if(valid) {
            setVendorInformationComplete(true);
            setVendorInformationActive(false);
            if(!rejectionRecord) {
                setContactInformationShown(true);
                setContactInformationActive(true);
            };
        }
        else{
            setVendorInformationComplete(false);
            setVendorInformationActive(true);
        }
    };

    // VENDOR
    const checkVendorInformation = () => {
        let complete = true
        if(zip.length >= 5){
            setZipComplete(true);
        }
        else{
            setZipComplete(false)
            complete = false;
        };

        if(String(fedEinSSn).length === 9){
            setFedEinSSnComplete(true);
        }
        else{
            setFedEinSSnComplete(false)
            complete = false;
        };

        if(legalName.length > 2) {
            setLegalNameComplete(true);
        }
        else{
            setLegalNameComplete(false)
            complete = false;
        };

        if(businessName.length > 2) {
            setBusinessNameComplete(true);
        }
        else{
            setBusinessNameComplete(false)
            complete = false;
        };

        if(street.length > 5) {
            setStreetComplete(true);
        }
        else{
            setStateComplete(false)
            complete = false;
        };

        if(city.length > 2) {
            setCityComplete(true);
        }
        else{
            setCityComplete(false)
            complete = false;
        };

        if(state.length > 1) {
            setStateComplete(true);
        }
        else{
            setStateComplete(false)
            complete = false;
        };

        return complete;
    };
    const vendorInformationProps = {
        formType:formType,
        vendorInformationActive:vendorInformationActive,
        setFedEinSSn:setFedEinSSn,
        fedEinSSn:fedEinSSn,
        fedEinSSnComplete:fedEinSSnComplete,
        setLegalName:setLegalName,
        legalName:legalName,
        legalNameComplete:legalNameComplete,
        setBusinessName:setBusinessName,
        businessName:businessName,
        businessNameComplete:businessNameComplete,
        setStreet:setStreet,
        street:street,
        street2:street2,
        setStreet2:setStreet2,
        streetComplete:streetComplete,
        setCity:setCity,
        city:city,
        cityComplete:cityComplete,
        setState:setState,
        state:state,
        stateComplete:stateComplete,
        setZip:setZip,
        zip:zip,
        zipComplete:zipComplete,
        setCountry:setCountry,
        country:country,
    };
    useEffect(() => {
        transitionFromVendor(checkVendorInformation());
    },[fedEinSSn,legalName,businessName,street,city,state,zip])

    // *TRANSITION* - - - - CONTACTS <-> REMIT
    const transitionFromContact = (valid) => {
        if(valid) {
            setContactInformationActive(false);
            if(!rejectionRecord) {
                setRemitInformationShown(true);
                setRemitInformationActive(true);
            };
        }
        else{
            setContactInformationActive(true);
        }
    };

    // CONTACT
    const checkContactInformation = () => {
        let complete = true;

        if(primaryContactFirstName.length > 2) setPrimaryContactFirstNameComplete(true);
        else{
            setPrimaryContactFirstNameComplete(false);
            complete = false;
        };

        if(primaryContactLastName.length > 2) setPrimaryContactLastNameComplete(true);
        else{
            setPrimaryContactLastNameComplete(false);
            complete = false;
        };

        if(primaryContactNumber.length === 10) setPrimaryContactNumberComplete(true);
        else{
            setPrimaryContactNumberComplete(false);
            complete = false;
        };

        if(checkEmail(primaryContactEmail)) setPrimaryContactEmailComplete(true);
        else{
            setPrimaryContactEmailComplete(false);
            complete = false;
        };



        return complete;
    };
    useEffect(() => {
        if(checkContactInformation()) transitionFromContact(true);
        else transitionFromContact(false);
    },[primaryContactFirstName,primaryContactLastName,primaryContactTitle,primaryContactNumber,primaryContactNumberExtension,primaryContactEmail]);
    // PROPS
    const contactInformationProps = {
        contactInformationShown:contactInformationShown,
        contactInformationActive:contactInformationActive,
        setPrimaryContactFirstName:setPrimaryContactFirstName,
        setPrimaryContactLastName:setPrimaryContactLastName,
        primaryContactFirstName: primaryContactFirstName,
        primaryContactLastName: primaryContactLastName,
        primaryContactFirstNameComplete:primaryContactFirstNameComplete,
        primaryContactLastNameComplete:primaryContactLastNameComplete,
        primaryContactTitle,primaryContactTitle,
        setPrimaryContactTitle:setPrimaryContactTitle,
        setPrimaryContactNumber:setPrimaryContactNumber,
        primaryContactNumber:primaryContactNumber,
        primaryContactNumberComplete:primaryContactNumberComplete,
        setPrimaryContactNumberExtension:setPrimaryContactNumberExtension,
        primaryContactNumberExtension:primaryContactNumberExtension,
        setPrimaryContactEmail:setPrimaryContactEmail,
        primaryContactEmail:primaryContactEmail,
        primaryContactEmailComplete:primaryContactEmailComplete,
    };

    // *TRANSITION* - - - - Remit <-> PAYMENT
    const transitionFromRemit = (valid) => {
        if(valid) {
            setRemitInformationActive(false);
            setRemitComplete(true);
            setPaymentInformationShown(true);
            setPaymentInformationActive(true);
        }
        else{
            setRemitInformationActive(true);
            setRemitComplete(false);
        };
    };

    const checkRemitInformation = () => {
        let complete = true;

        if(remitFirstName1 && remitFirstName1.length > 2) setRemitFirstName1Complete(true);
        else{
            setRemitFirstName1Complete(false);
            complete = false;
        };

        if(remitLastName1 && remitLastName1.length > 2) setRemitLastName1Complete(true);
        else{
            setRemitLastName1Complete(false);
            complete = false;
        };

        if(remitNumber1 && remitNumber1.length === 10) setRemitNumber1Complete(true);
        else{
            setRemitNumber1Complete(false);
            complete = false;
        };

        if(checkEmail(remitEmail1)) setRemitEmail1Complete(true);
        else{
            setRemitEmail1Complete(false);
            complete = false;
        };

        if(remitContact2){
            if(remitFirstName2 && remitFirstName2.length > 2) setRemitFirstName2Complete(true);
            else{
                setRemitFirstName2Complete(false);
                complete = false;
            };

            if(remitLastName2 && remitLastName2.length > 2) setRemitLastName2Complete(true);
            else{
                setRemitLastName2Complete(false);
                complete = false;
            };

            if(remitNumber2 && remitNumber2.length === 10) setRemitNumber2Complete(true);
            else{
                setRemitNumber2Complete(false);
                complete = false;
            };

            if(checkEmail(remitEmail2)) setRemitEmail2Complete(true);
            else{
                setRemitEmail2Complete(false);
                complete = false;
            };
        }

        return complete;
    };
    useEffect(() => {
        transitionFromRemit(checkRemitInformation());
    },[remitFirstName1,remitLastName1,remitTitle1,remitNumber1,remitNumberExtension1,remitEmail1, remitContact2, remitFirstName2, remitTitle2, remitLastName2, remitNumber2, remitNumberExtension2, remitEmail2]);

    const setRemitToPrimaryContact = () => {
        setRemitFirstName1(primaryContactFirstName);
        setRemitLastName1(primaryContactLastName);
        setRemitTitle1(primaryContactTitle);
        setRemitNumber1(primaryContactNumber);
        setRemitNumberExtension1(primaryContactNumberExtension);
        setRemitEmail1(primaryContactEmail);
        setRemitContact2(false);
    };

    // PROPS
    const remitInformationProps = {
        remitInformationShown:remitInformationShown,
        remitInformationActive:remitInformationActive,
        setRemitFirstName1:setRemitFirstName1,
        setRemitLastName1:setRemitLastName1,
        remitFirstName1: remitFirstName1,
        remitLastName1: remitLastName1,
        remitFirstName1Complete:remitFirstName1Complete,
        remitLastName1Complete:remitLastName1Complete,
        remitTitle1,remitTitle1,
        setRemitTitle1:setRemitTitle1,
        setRemitNumber1:setRemitNumber1,
        remitNumber1:remitNumber1,
        remitNumber1Complete:remitNumber1Complete,
        setRemitNumberExtension1:setRemitNumberExtension1,
        remitNumberExtension1:remitNumberExtension1,
        setRemitEmail1:setRemitEmail1,
        remitEmail1:remitEmail1,
        remitEmail1Complete:remitEmail1Complete,
        remitContact2: remitContact2,
        setRemitContact2: setRemitContact2,
        setRemitFirstName2:setRemitFirstName2,
        setRemitLastName2:setRemitLastName2,
        remitFirstName2:remitFirstName2,
        remitLastName2:remitLastName2,
        remitFirstName2Complete:remitFirstName2Complete,
        remitLastName2Complete:remitLastName2Complete,
        remitTitle2,remitTitle2,
        setRemitTitle2:setRemitTitle2,
        setRemitNumber2:setRemitNumber2,
        remitNumber2:remitNumber2,
        remitNumber2Complete:remitNumber2Complete,
        setRemitNumberExtension2:setRemitNumberExtension2,
        remitNumberExtension2:remitNumberExtension2,
        setRemitEmail2:setRemitEmail2,
        remitEmail2:remitEmail2,
        remitEmail2Complete:remitEmail2Complete,
        setRemitToPrimaryContact:setRemitToPrimaryContact,
        primaryContactFirstName:primaryContactFirstName,
        primaryContactLastName:primaryContactLastName,
        primaryContactTitle:primaryContactTitle,
        primaryContactNumber:primaryContactNumber,
        primaryContactNumberExtension:primaryContactNumberExtension,
        primaryContactEmail:primaryContactEmail
    };


    // *TRANSITION* - - - - PAYMENT <-> W9
    const transferFromPayment = (valid) => {
        if(valid){
            setPaymentInformationActive(false);
            setW9Shown(true);
            setW9Active(true);
            if(rejectionRecord) setW9Active(false);
        }
        else{
            setPaymentInformationActive(true);
            setW9Shown(false);
            setW9Active(false);  
        }
    };
    // PAYMENT
    useEffect(() => {    // TRIGGER CUSTOM TERMS
        if(paymentTerms === 'Other'){
            setCustomTermsShown(true);
        }
        else{
            setCustomTermsShown(false);
        }
    },[paymentTerms]);

    const checkPaymentInformation = () => {
        let complete = true;

        if(vendorTypeSelection && vendorTypeSelection !== 'false') setVendorTypeSelectionComplete(true);
        else{
            setVendorTypeSelectionComplete(false);
            complete = false;
        };

        if(paymentMethod && paymentMethod !== 'false') setPaymentMethodComplete(true);
        else{
            setPaymentMethodComplete(false);
            complete = false;
        };

        if(paymentTermNames && paymentTermNames !== '') setPaymentTermNamesComplete(true);
        else{
            setPaymentTermNamesComplete(false);
            complete = false;
        };

        if(invoiceCurrency && invoiceCurrency !== '') setInvoiceCurrencyComplete(true);
        else{
            setInvoiceCurrencyComplete(false);
            complete = false;
        };

        return complete;
    };

    useEffect(() => {
        setPaymentTerms(paymentTermsObject[paymentTermNames]);
    },[paymentTermNames]);

    useEffect(() => {
        if(invoiceCurrency === 'CAD') setPaymentMethod('International Wire');
    },[invoiceCurrency]);

    useEffect(() => {
        if(checkPaymentInformation()) transferFromPayment(true);
        else transferFromPayment(false);
    },[vendorTypeSelection, paymentMethod, paymentTerms, customTerms, invoiceCurrency, paymentTermNames]);
    //PROPS
    const paymentInformationProps = {
        paymentInformationShown:paymentInformationShown,
        paymentInformationActive:paymentInformationActive,
        vendorTypeOptions:vendorTypeOptions,
        setVendorTypeSelection:setVendorTypeSelection,
        vendorTypeSelection:vendorTypeSelection,
        vendorTypeSelectionComplete:vendorTypeSelectionComplete,
        paymentTypes:paymentTypes,
        setPaymentMethod:setPaymentMethod,
        paymentMethod:paymentMethod,
        paymentMethodComplete:paymentMethodComplete,
        paymentTermNamesOptions:paymentTermNamesOptions,
        setPaymentTermNames:setPaymentTermNames,
        paymentTermNames:paymentTermNames,
        paymentTermNamesComplete:paymentTermNamesComplete,
        setInvoiceCurrency:setInvoiceCurrency,
        invoiceCurrency:invoiceCurrency,
        invoiceCurrencyOptions:invoiceCurrencyOptions,
        invoiceCurrencyComplete:invoiceCurrencyComplete,
        customTermsShown:customTermsShown,
        setCustomTerms:setCustomTerms,
        businessClassifications:businessClassifications,
        classificationList:classificationList,
        setClassificationList:setClassificationList,
    };

    // *TRANSITION* - - - - ACH
    const transitionFromAch = (valid) => {
        if(valid){
            setAchActive(false);
            setAchComplete(true);
        }
        else{
            setAchActive(true);
            setAchComplete(false);
        }
    };
    // ACH
    const checkAchInformation = () => {
        let complete = true;

        if(bankName.length > 2) setBankNameComplete(true);
        else{
            setBankNameComplete(false);
            complete = false;
        };

        if(bankContactFirstName.length > 2) setBankContactFirstNameComplete(true);
        else{
            setBankContactFirstNameComplete(false);
            complete = false;
        };

        if(bankContactLastName.length > 2) setBankContactLastNameComplete(true);
        else{
            setBankContactLastNameComplete(false);
            complete = false;
        };

        if(bankStreet.length > 2) setBankStreetComplete(true);
        else{
            setBankStreetComplete(false);
            complete = false;
        };

        if(bankCity.length > 2) setBankCityComplete(true);
        else{
            setBankCityComplete(false);
            complete = false;
        };

        if(bankState.length > 1) setBankStateComplete(true);
        else{
            setBankStateComplete(false);
            complete = false;
        };

        if(bankZip.length >= 5) setBankZipComplete(true);
        else{
            setBankZipComplete(false);
            complete = false;
        };

        if(bankTelephone.length === 10) setBankTelephoneComplete(true);
        else{
            setBankTelephoneComplete(false);
            complete = false;
        };
        
        if(checkEmail(bankContactEmail)) setBankContactEmailComplete(true);
        else{
            setBankContactEmailComplete(false);
            complete = false;
        };

        if(bankVendorStreet.length > 2) setBankVendorStreetComplete(true);
        else{
            setBankVendorStreetComplete(false);
            complete = false;
        };

        if(bankVendorCity.length > 2) setBankVendorCityComplete(true);
        else{
            setBankVendorCityComplete(false);
            complete = false;
        };

        if(bankVendorState.length > 1) setBankVendorStateComplete(true);
        else{
            setBankVendorStateComplete(false);
            complete = false;
        };

        if(bankVendorZip.length >= 5) setBankVendorZipComplete(true);
        else{
            setBankVendorZipComplete(false);
            complete = false;
        };

        if(bankAccountName.length > 2) setBankAccountNameComplete(true);
        else{
            setBankAccountNameComplete(false);
            complete = false;
        };

        if(bankAccountNumber.length > 7) setBankAccountNumberComplete(true);
        else{
            setBankAccountNumberComplete(false);
            complete = false;
        };

        if(bankRoutingNumber.length === 9) setBankRoutingNumberComplete(true);
        else{
            setBankRoutingNumberComplete(false);
            complete = false;
        };

        if(bankAccountSelection && bankAccountSelection !== '') setBankAccountSelectionComplete(true);
        else{
            setBankAccountSelectionComplete(false);
            complete = false;
        };

        return complete;
    };
    useEffect(() => { // CHECKS FOR TRANSITION READY
        if(checkAchInformation()) transitionFromAch(true);
        else transitionFromAch(false);
    },[bankName,bankContactFirstName,bankContactLastName,bankStreet,bankCity,bankState,bankZip,bankTelephone,bankContactEmail,
    bankVendorStreet,bankVendorCity,bankVendorState,bankVendorZip,bankAccountName,
    bankAccountNumber,bankRoutingNumber,bankAccountSelection,rejectionRecord]);
    const achProps = {
        achActive:achActive,
        setBankName:setBankName,
        bankName:bankName,
        bankNameComplete:bankNameComplete,
        setBankContactFirstName:setBankContactFirstName,
        bankContactFirstName:bankContactFirstName,
        setBankContactLastName:setBankContactLastName,
        bankContactLastName:bankContactLastName,
        bankContactFirstNameComplete:bankContactFirstNameComplete,
        bankContactLastNameComplete:bankContactLastNameComplete,
        setBankStreet:setBankStreet,
        bankStreet:bankStreet,
        setBankStreet2:setBankStreet2,
        bankStreet2:bankStreet2,
        bankStreetComplete:bankStreetComplete,
        setBankCity:setBankCity,
        bankCity:bankCity,
        bankCityComplete:bankCityComplete,
        setBankState:setBankState,
        bankState:bankState,
        bankStateComplete:bankStateComplete,
        setBankZip:setBankZip,
        bankZip:bankZip,
        bankZipComplete:bankZipComplete,
        setBankCountry:setBankCountry,
        bankCountry:bankCountry,
        bankCountryComplete:bankCountryComplete,
        setBankTelephone:setBankTelephone,
        bankTelephone:bankTelephone,
        bankTelephoneComplete:bankTelephoneComplete,
        setBankContactEmail:setBankContactEmail,
        bankContactEmail:bankContactEmail,
        bankContactEmailComplete:bankContactEmailComplete,
        setBankVendorStreet:setBankVendorStreet,
        bankVendorStreet:bankVendorStreet,
        setBankVendorStreet2:setBankVendorStreet2,
        bankVendorStreet2:bankVendorStreet2,
        bankVendorStreetComplete:bankVendorStreetComplete,
        setBankVendorCity:setBankVendorCity,
        bankVendorCity:bankVendorCity,
        bankVendorCityComplete:bankVendorCityComplete,
        setBankVendorState:setBankVendorState,
        bankVendorState:bankVendorState,
        bankVendorStateComplete:bankVendorStateComplete,
        setBankVendorZip:setBankVendorZip,
        bankVendorZip:bankVendorZip,
        bankVendorZipComplete:bankVendorZipComplete,
        setBankVendorCountry:setBankVendorCountry,
        bankVendorCountry:bankVendorCountry,
        setBankAccountName:setBankAccountName,
        bankAccountName:bankAccountName,
        bankAccountNameComplete:bankAccountNameComplete,
        setBankAccountNumber:setBankAccountNumber,
        bankAccountNumber:bankAccountNumber,
        bankAccountNumberComplete:bankAccountNumberComplete,
        setBankRoutingNumber:setBankRoutingNumber,
        bankRoutingNumber:bankRoutingNumber,
        bankRoutingNumberComplete:bankRoutingNumberComplete,
        setBankAccountSelection:setBankAccountSelection,
        bankAccountSelection:bankAccountSelection,
        bankAccountSelectionComplete:bankAccountSelectionComplete,
    };
    useEffect(() => {    // TRIGGER ACH & INT WIRE WINDOW SHOW
        if(paymentMethod === 'ACH'){
            
            setAchShown(true);
            setVoidedCheckShown(true);
            if(!rejectionRecord){
                setVoidedCheckActive(true);
                setAchActive(true);
            };
            if(rejectionRecord && !rejectionRecord.vendorProfile.voidedCheck) {
                setVoidedCheckActive(true);
                setAchActive(true);
            };
            setIntWireActive(false);
            setIntWireShown(false);
        }
        else if(paymentMethod === 'International Wire'){
            if(!rejectionRecord) setIntWireActive(true);
            if(rejectionRecord && !rejectionRecord.vendorProfile.internationalWire) setIntWireActive(true);
            setIntWireShown(true);
            setAchActive(false);
            setAchShown(false);
            setVoidedCheckShown(false);
            setVoidedCheckActive(false);
        }
        else{
            setAchActive(false);
            setAchShown(false);
            setVoidedCheckShown(false);
            setVoidedCheckActive(false);
            setIntWireActive(false);
            setIntWireShown(false);
        };
    },[paymentMethod]);



    // VOIDED CHECK
    useEffect(() => {
        if(!rejectionRecord) {
            if(voidedCheckFile) {
                setVoidedCheckActive(false);
                setVoidedCheckComplete(true);
            }
            else{
                setVoidedCheckActive(true);
                setVoidedCheckComplete(false);
            };
        }
        else{
            if(voidedCheckFile) {
                setVoidedCheckActive(false);
                setVoidedCheckComplete(true);
            }
            else{
                if(!rejectionRecord.vendorProfile.voidedCheck) {
                    setVoidedCheckActive(true);
                    setVoidedCheckComplete(false);
                }
                else {
                    setVoidedCheckActive(false);
                    setVoidedCheckComplete(true);
                };
            };
        };
    },[voidedCheckFile, rejectionRecord]);
    const submitVoidedCheck = () => {
        const extension = voidedCheckFile[0].type
        const filename = `${businessName}-Voided Check-${getDate()}.${extension.replace(/(.*)\//g, '')}`;
        sendVoidedCheck(voidedCheckFile[0], filename, setVoidedCheckId, setVoidedCheckError);
    };

    // COI
    useEffect(() => {
        if(!rejectionRecord) {
            if(coiFile){
                setCoiActive(false);
                setCoiComplete(true);
            }
            else{
                setCoiActive(true);
                setCoiComplete(false);
            };
        }
        else{
            if(coiFile){
                setCoiActive(false);
                setCoiComplete(true);
            }
            else{
                if(!rejectionRecord.vendorProfile.coi) {
                    setCoiActive(true);
                    setCoiComplete(false);
                }
                else {
                    setCoiActive(false);
                    setCoiComplete(true);
                };
            };
        };
    },[coiFile, rejectionRecord]);
    const submitCOI = () => {
        const extension = coiFile[0].type
        const filename = `${businessName}-COI-${getDate()}.${extension.replace(/(.*)\//g, '')}`;
        sendCoi(coiFile[0], filename, setCoiId, setCoiError);
    };
    useEffect(() => {    // TRIGGER COI WINDOW SHOW
        if(!rejectionRecord) {
            if(vendorTypeSelection === 'Subcontractor'){
                setCoiActive(true);
                setCoiShown(true);
            }
            else{
                setCoiActive(false);
                setCoiShown(false);
            };
        }
        else{
            if(rejectionRecord.vendorProfile.coi){
                setCoiActive(false);
                setCoiShown(false);
            }
            else{
                setCoiActive(true);
                setCoiShown(true);
            };
        }


    },[vendorTypeSelection]);

    // W9
    const downloadBlankW9 = () => {
        getBlankW9();
    };
    const submitW9 = () => {
        const extension = finishedW9[0].type
        const filename = `${businessName}-W9-${getDate()}.${extension.replace(/(.*)\//g, '')}`;
        sendW9(finishedW9[0], filename, setW9Id, setW9Error);
    };
    useEffect(() => {
        if(!rejectionRecord){
            if(finishedW9) {
                setW9Active(false);
                setW9Complete(true);
            }
            else {
                setW9Active(true);
                setW9Complete(false);
            };
        }
        else{
            if(finishedW9) {
                setW9Active(false);
                setW9Complete(true);
            }
            else{
                if(!rejectionRecord.vendorProfile.w9) {
                    setW9Active(true);
                    setW9Complete(false);
                }
                else {
                    setW9Active(false);
                    setW9Complete(true);
                }
            };
        };
        
    },[finishedW9, rejectionRecord]);

    // Internation Wire
    const submitIntWire = () => {
        const extension = intWire[0].type
        const filename = `${businessName}-Int Wire-${getDate()}.${extension.replace(/(.*)\//g, '')}`;
        sendInternationalWire(intWire[0], filename, setIntWireId, setIntWireError);
    };
    useEffect(() => {
        if(!rejectionRecord){
            if(intWire) {
                setIntWireActive(false);
                setIntWireComplete(true);
            }
            else{
                setIntWireActive(true);
                setIntWireComplete(false);
            };
        }
        else{
            if(intWire) {
                setIntWireActive(false);
                setIntWireComplete(true);
            }
            else{
                if(!rejectionRecord.vendorProfile.internationalWire) {
                    setIntWireActive(true);
                    setIntWireComplete(false);
                }
                else {
                    setIntWireActive(false);
                    setIntWireComplete(true);
                };
            };
        };
    },[intWire, rejectionRecord]);

    // Business Classification
    const submitBusinessClassification = () => {
        const extension = businessClassification[0].type
        const filename = `${businessName}-Business Classification-${getDate()}.${extension.replace(/(.*)\//g, '')}`;
        sendBusinessClassification(businessClassification[0], filename, setBusinessClassificationId, setBusinessClassificationError);
    };
    useEffect(() => {
        if(!rejectionRecord){
            if(businessClassification) {
                setBusinessClassificationActive(false);
                setBusinessClassificationComplete(true);
            }
            else{
                setBusinessClassificationActive(true);
                setBusinessClassificationComplete(false);
            };
        } else{
            if(businessClassification) {
                setBusinessClassificationActive(false);
                setBusinessClassificationComplete(true);
            }
            else{
                if(!rejectionRecord.vendorProfile.businessClassification) {
                    console.log('NO BUSINESS CLASSIFICATION');
                    setBusinessClassificationActive(true);
                    setBusinessClassificationComplete(false);
                }
                else {
                    setBusinessClassificationActive(false);
                    setBusinessClassificationComplete(true);
                };
            };
        };
    },[businessClassification, rejectionRecord]);

    useEffect(() => {
        if(!rejectionRecord){
            if(classificationList && classificationList.length > 0) {
                setBusinessClassificationActive(true);
                setBusinessClassificationShown(true);
            }
            else {
                setBusinessClassificationActive(false);
                setBusinessClassificationShown(false);
            }
        } else {
            if(classificationList && classificationList.length > 0 && !rejectionRecord.vendorProfile.businessClassification) {
                setBusinessClassificationActive(true);
                setBusinessClassificationShown(true);
            }
            else if(classificationList && classificationList.length > 0 && rejectionRecord.vendorProfile.businessClassification) {
                setBusinessClassificationActive(false);
                setBusinessClassificationShown(true);
            }
            else {
                setBusinessClassificationActive(false);
                setBusinessClassificationShown(false);
            }
        }

    },[classificationList]);

    //  FILES INFORMATION
    const checkFiles = () => {
        let complete = true;

        if(!rejectionRecord){
            if(voidedCheckShown) if(!voidedCheckComplete) complete = false;
            if(coiShown) if(!coiComplete) complete = false;
            if(intWireShown) if(!intWireComplete) complete = false;
            if(!w9Complete) complete = false;
            if(businessClassificationShown) if(!businessClassificationComplete) complete = false;
        }
        else{
            if(!w9Complete || !rejectionRecord.vendorProfile.w9) complete = false;
            if(intWireShown && (!intWireComplete || !rejectionRecord.vendorProfile.internationalWire)) complete = false;
            if(voidedCheckShown && (!voidedCheckComplete || !rejectionRecord.vendorProfile.voidedCheck)) complete = false;
            if(coiShown && (!coiComplete || !rejectionRecord.vendorProfile.coi)) complete = false;
            if(businessClassificationShown && (!businessClassificationComplete || !rejectionRecord.vendorProfile.businessClassification)) complete = false;
        };
        
        return complete;
    };

    // READY FOR CONDITIONS
    const readyToConfirm = () => {
        let ready = true;
        if(typeActive) ready = false;
        if(!vendorInformationComplete) ready = false;
        if(contactInformationShown) if(contactInformationActive) ready = false;
        if(remitInformationShown) if(!remitComplete) ready = false;
        if(paymentInformationShown) if(paymentInformationActive) ready = false;
        if(achShown) if(!achComplete) ready = false;
        if(!checkFiles()) ready = false
    

        return ready;
    };
    useEffect(() => {
        if(readyToConfirm()) setConditionsShown(true);
        else setConditionsShown(false);
    },[typeActive,vendorInformationComplete,contactInformationActive,remitInformationActive,remitComplete,paymentInformationActive,achComplete,
        voidedCheckComplete,coiComplete,intWireComplete,w9Complete,voidedCheckActive,coiActive,finishedW9,intWireActive]);

    // CONDITIONS & SIGNATURE
    const checkConditionsComplete = () => {
        let complete = true;

        if(signature.length > 3) setSignatureComplete(true);
        else{
            setSignatureComplete(false);
            complete = false;
        };

        if(officerName.length > 3) setOfficerNameComplete(true);
        else{
            setOfficerNameComplete(false);
            complete = false;
        };

        if(officerTitle.length > 2) setOfficerTitleComplete(true);
        else{
            setOfficerTitleComplete(false);
            complete = false;
        };

        if(!termsAccepted) complete = false;

        setConditionsComplete(complete);
    };
    useEffect(() => {
        checkConditionsComplete();
    },[signature,officerName,officerTitle,termsAccepted]);

    const conditionsProps = {
        termsAccepted:termsAccepted,
        setTermsAccepted:setTermsAccepted,
        setOfficerName:setOfficerName,
        officerName:officerName,
        officerNameComplete:officerNameComplete,
        setOfficerTitle:setOfficerTitle,
        officerTitle:officerTitle,
        officerTitleComplete:officerTitleComplete,
        setSignature:setSignature,
        signatureComplete:signatureComplete,
        signature:signature,
    };

    // SUBMITTING FORM
    const setFormComplete = () => {
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem(draftStorageKey);
        }
        setFinalizedSubmitted(true);
    };

    const addIdsToVendorRecord = (vendorObject) => {
        vendorObject.id = rejectionRecord.vendorProfile.id;
        vendorObject.businessAddressId = rejectionRecord.vendorProfile.businessAddress.id;
        if(rejectionRecord.vendorProfile.bankAccount){
            vendorObject.bankAccountId = rejectionRecord.vendorProfile.bankAccount.id;
            vendorObject.bankAccountAddressId = rejectionRecord.vendorProfile.bankAccount.address.id;
            vendorObject.bankAccountContactId = rejectionRecord.vendorProfile.bankAccount.contact.id;
        };
        vendorObject.primaryContactId = rejectionRecord.vendorProfile.primaryContact.id;
        vendorObject.remitContact1Id = rejectionRecord.vendorProfile.remitContact1.id;
        if(rejectionRecord.vendorProfile.remitContact2) vendorObject.remitContact2Id = rejectionRecord.vendorProfile.remitContact2.id;

        return vendorObject;

    };

    const createVendorRecordObject = () => {
        // CREATE OBJECT
        const vendorObject = {
            formType: formType,
            fedEinSSn: fedEinSSn,
            legalName:legalName,
            businessName:businessName,
            street:street,
            street2:street2,
            city:city,
            state:state,
            zip:zip,
            country:country,
            primaryContactFirstName:primaryContactFirstName,
            primaryContactLastName:primaryContactLastName,
            primaryContactTitle:primaryContactTitle,
            primaryContactNumber:primaryContactNumber,
            primaryContactNumberExtension:primaryContactNumberExtension,
            primaryContactEmail:primaryContactEmail,
            remitFirstName1:remitFirstName1,
            remitLastName1:remitLastName1,
            remitTitle1:remitTitle1,
            remitNumber1:remitNumber1,
            remitNumberExtension1:remitNumberExtension1,
            remitEmail1:remitEmail1,
            remitFirstName2:remitFirstName2,
            remitLastName2:remitLastName2,
            remitTitle2:remitTitle2,
            remitNumber2:remitNumber2,
            remitNumberExtension2:remitNumberExtension2,
            remitEmail2:remitEmail2,
            vendorType:vendorTypeSelection,
            paymentMethod:paymentMethod,
            classificationList:classificationList,
            paymentTerms:paymentTerms,
            paymentTermsName:paymentTermNames,
            invoiceCurrency:invoiceCurrency,
            customTerms:customTerms,
            bankName:bankName,
            bankContactFirstName:bankContactFirstName,
            bankContactLastName:bankContactLastName,
            bankStreet:bankStreet,
            bankStreet2:bankStreet2,
            bankCity:bankCity,
            bankState:bankState,
            bankZip:bankZip,
            bankCountry:bankCountry,
            bankTelephone:bankTelephone,
            bankContactEmail:bankContactEmail,
            bankVendorStreet:bankVendorStreet,
            bankVendorStreet2:bankVendorStreet2,
            bankVendorCity:bankVendorCity,
            bankVendorState:bankVendorState,
            bankVendorZip:bankVendorZip,
            bankVendorCountry:bankVendorCountry,
            bankAccountName:bankAccountName,
            bankAccountNumber:bankAccountNumber,
            bankRoutingNumber:bankRoutingNumber,
            bankAccountSelection:bankAccountSelection,
            voidedCheckId:voidedCheckId,
            coiId:coiId,
            officerName:officerName,
            officerTitle:officerTitle,
            signature: signature,
            intWireId:intWireId,
            w9Id:w9Id,
            businessClassificationId:businessClassificationId,
            notificationEmail:notificationEmail,
        };

        if(rejectionRecord){
            vendorObject.id = rejectionRecord.vendorProfile.id;
            vendorObject.businessAddressId = rejectionRecord.vendorProfile.businessAddress.id;
            if(rejectionRecord.vendorProfile.bankAccount) vendorObject.bankAccountId = rejectionRecord.vendorProfile.bankAccount.id;
            vendorObject.primaryContactId = rejectionRecord.vendorProfile.primaryContact.id;
            vendorObject.remitContact1Id = rejectionRecord.vendorProfile.remitContact1.id;
            if(rejectionRecord.vendorProfile.remitContact2) vendorObject.remitContact2Id = rejectionRecord.vendorProfile.remitContact2.id;
            vendorObject.rejectionId = rejectionRecord.id;
        };

        return vendorObject;
    };

    useEffect(() => {
        if (!draftHydrated) return;
        if (submitting || finalizedSubmitting) return;
        if (typeof window === 'undefined') return;

        try {
            window.localStorage.setItem(draftStorageKey, JSON.stringify(buildDraftPayload()));
        }
        catch (e) {
            console.error('Unable to save vendor draft', e);
        }
    }, [
        draftHydrated,
        submitting,
        finalizedSubmitting,
        draftStorageKey,
        formType,
        fedEinSSn,
        legalName,
        businessName,
        street,
        street2,
        city,
        state,
        zip,
        country,
        primaryContactFirstName,
        primaryContactLastName,
        primaryContactTitle,
        primaryContactNumber,
        primaryContactNumberExtension,
        primaryContactEmail,
        remitFirstName1,
        remitLastName1,
        remitTitle1,
        remitNumber1,
        remitNumberExtension1,
        remitEmail1,
        remitContact2,
        remitFirstName2,
        remitLastName2,
        remitTitle2,
        remitNumber2,
        remitNumberExtension2,
        remitEmail2,
        vendorTypeSelection,
        paymentMethod,
        classificationList,
        paymentTerms,
        paymentTermNames,
        customTerms,
        invoiceCurrency,
        bankName,
        bankContactFirstName,
        bankContactLastName,
        bankStreet,
        bankStreet2,
        bankCity,
        bankState,
        bankZip,
        bankCountry,
        bankTelephone,
        bankContactEmail,
        bankVendorStreet,
        bankVendorStreet2,
        bankVendorCity,
        bankVendorState,
        bankVendorZip,
        bankVendorCountry,
        bankAccountName,
        bankAccountNumber,
        bankRoutingNumber,
        bankAccountSelection,
        officerName,
        officerTitle,
        signature,
        termsAccepted,
    ]);

    const submitVendorRecord = () => {
        const vendorObject = createVendorRecordObject();
        // SEND OBJECT
        sendVendorRecord(vendorObject, setFormComplete, setVendorRecordError, encryptionKey);
    };

    const putVendorRecord = () => {
        const vendorObject = createVendorRecordObject();
        const finalUpdatedVendorObject = addIdsToVendorRecord(vendorObject);
        console.log(finalUpdatedVendorObject);
        // SEND OBJECT
        updateVendorRecord(finalUpdatedVendorObject, setFormComplete, setVendorRecordError, encryptionKey);
    };

    const hasSelectedFile = (fileCollection) => Boolean(fileCollection && fileCollection.length > 0);

    const missingRequiredAttachments = [];
    if (voidedCheckShown && !hasSelectedFile(voidedCheckFile) && !(rejectionRecord && rejectionRecord.vendorProfile && rejectionRecord.vendorProfile.voidedCheck)) {
        missingRequiredAttachments.push('Voided Check or Bank Letter');
    }
    if (coiShown && !hasSelectedFile(coiFile) && !(rejectionRecord && rejectionRecord.vendorProfile && rejectionRecord.vendorProfile.coi)) {
        missingRequiredAttachments.push('COI');
    }
    if (intWireShown && !hasSelectedFile(intWire) && !(rejectionRecord && rejectionRecord.vendorProfile && rejectionRecord.vendorProfile.internationalWire)) {
        missingRequiredAttachments.push('International Wire Instructions');
    }
    if (w9Shown && !hasSelectedFile(finishedW9) && !(rejectionRecord && rejectionRecord.vendorProfile && rejectionRecord.vendorProfile.w9)) {
        missingRequiredAttachments.push('W9');
    }
    if (businessClassificationShown && !hasSelectedFile(businessClassification) && !(rejectionRecord && rejectionRecord.vendorProfile && rejectionRecord.vendorProfile.businessClassification)) {
        missingRequiredAttachments.push('Proof of Business Classification');
    }

    const requiredAttachmentsReady = missingRequiredAttachments.length === 0;

    const submitForm = () => {
        setAttachmentValidationError('');

        const missingAttachments = [...missingRequiredAttachments];

        // Cached drafts do not retain File objects; require explicit re-attach before submit.
        if (missingAttachments.includes('Voided Check or Bank Letter')) {
            setVoidedCheckActive(true);
            setVoidedCheckComplete(false);
        }
        if (missingAttachments.includes('COI')) {
            setCoiActive(true);
            setCoiComplete(false);
        }
        if (missingAttachments.includes('International Wire Instructions')) {
            setIntWireActive(true);
            setIntWireComplete(false);
        }
        if (missingAttachments.includes('W9')) {
            setW9Active(true);
            setW9Complete(false);
        }
        if (missingAttachments.includes('Proof of Business Classification')) {
            setBusinessClassificationActive(true);
            setBusinessClassificationComplete(false);
        }

        if (missingAttachments.length > 0) {
            setAttachmentValidationError(`Please reattach required file(s): ${missingAttachments.join(', ')}.`);
            return;
        }

        setSubmitting(true);

        if(voidedCheckShown && voidedCheckFile) submitVoidedCheck();
        if(voidedCheckShown && !voidedCheckFile && !voidedCheckId && rejectionRecord && rejectionRecord.vendorProfile.voidedCheck) setVoidedCheckId(rejectionRecord.vendorProfile.voidedCheck);

        if(coiShown && coiFile) submitCOI();
        if(coiShown && !coiFile && !coiId && rejectionRecord && rejectionRecord.vendorProfile.coi) setCoiId(rejectionRecord.vendorProfile.coi);

        if(intWireShown && intWire) submitIntWire();
        if(intWireShown && !intWire && !intWireId && rejectionRecord && rejectionRecord.vendorProfile.internationalWire) setIntWireId(rejectionRecord.vendorProfile.internationalWire);

        if(finishedW9) submitW9();
        if(!finishedW9 && !w9Id && rejectionRecord && rejectionRecord.vendorProfile.w9) setW9Id(rejectionRecord.vendorProfile.w9);

        if(businessClassificationShown && businessClassification) submitBusinessClassification();
        if(businessClassificationShown && !businessClassification && !businessClassificationId && rejectionRecord && rejectionRecord.vendorProfile.businessClassification) setBusinessClassificationId(rejectionRecord.vendorProfile.businessClassification);
    };

    useEffect(() => {
        if (attachmentValidationError) {
            setAttachmentValidationError('');
        }
    }, [voidedCheckFile, coiFile, intWire, finishedW9, businessClassification]);

    useEffect(() => {
        let finalReady = true;
        if(!submitting) finalReady = false;

        if(voidedCheckShown && voidedCheckFile && !voidedCheckId){
            finalReady = false;
            setVoidedCheckUpdated(true);
        };
        
        if(coiShown && coiFile && !coiId){
            finalReady = false;
            setCoiUpdated(true);
        };
        
        if(finishedW9 && !w9Id){
            finalReady = false;
            setW9Updated(true);
        }; 
        
        if(intWireShown) if(intWire && !intWireId){
            finalReady = false;
            setIntWireUpdated(true);
        };

        if(businessClassificationShown) if(businessClassification && !businessClassificationId){
            finalReady = false;
            setBusinessClassificationUpdated(true);
        };
        
        if(finalReady && !submittingRecord){ 
            setSubmittingRecord(true);
            if(!rejectionRecord) submitVendorRecord();
            if(rejectionRecord) putVendorRecord();
        };
    },[voidedCheckId,coiId,w9Id,intWireId,businessClassificationId,submitting]);


    // RENDER NEW VENDOR PRIMARY
    return(
        <div className='External-Form-Window'>

            <div className='External-Form-Page'>

                <FormHeader formEmail={formEmail}/>



                {   !submitting && 
                    <>

                    {   rejectionRecord &&
                        <RejectionHeader {...rejectionProps}/>
                    }

                    <VendorInformation {...vendorInformationProps}/>

                    <ContactInformation {...contactInformationProps} />

                    <RemitInformation {...remitInformationProps} />
                    
                    <PaymentInformation {...paymentInformationProps}/>

                    {   achShown &&
                        <AchInformation {...achProps}/>
                    }   

                    {   intWireShown &&
                        <InternationWireInformation intWireActive={intWireActive} setIntWire={setIntWire}/>
                    }

                    {   voidedCheckShown &&
                        <VoidedCheckInformation voidedCheckActive={voidedCheckActive} setVoidedCheckFile={setVoidedCheckFile}/>
                    }

                    {   coiShown &&
                        <CoiInformation coiActive={coiActive} setCoiFile={setCoiFile}/>
                    }

                    {   businessClassificationShown &&
                        <BusinessClassificationInformation businessClassificationActive={businessClassificationActive} setBusinessClassification={setBusinessClassification}/>
                    }

                    {   w9Shown &&
                        <W9Section w9Active={w9Active} downloadBlankW9={downloadBlankW9} setFinishedW9={setFinishedW9}/>
                    }

                    {   conditionsShown &&
                        <ConditionsSection {...conditionsProps}/>
                    }

                    {   conditionsComplete && requiredAttachmentsReady && !rejectionRecord &&
                        <button onClick={() => submitForm()} className='External-Vendor-Submit External-Vendor-Button'>Submit Form</button>
                    }

                    {   conditionsComplete && requiredAttachmentsReady && rejectionRecord &&
                        <button onClick={() => submitForm()} className='External-Vendor-Submit External-Vendor-Button'>Resubmit Form</button>
                    }

                    {   conditionsComplete && !requiredAttachmentsReady && !attachmentValidationError &&
                        <div className='External-Vendor-Type-Error'>
                            Please reattach required file(s): {missingRequiredAttachments.join(', ')}.
                        </div>
                    }

                    {   attachmentValidationError &&
                        <div className='External-Vendor-Type-Error'>
                            {attachmentValidationError}
                        </div>
                    }

                    <img src={'https://www.positivessl.com/images/seals/positivessl_trust_seal_md_167x42.png'} className='External-Vendor-SSL'/>
                    </>
                }
                {   submitting &&
                    <FormSubmissionWindow coiId={coiId} coiShown={coiShown} voidedCheckId={voidedCheckId} voidedCheckShown={voidedCheckShown} 
                    w9Id={w9Id} intWireShown={intWireShown} intWireId={intWireId} businessClassificationShown={businessClassificationShown} businessClassificationId={businessClassificationId} finalizedSubmitting={finalizedSubmitting} 
                    w9Updated={w9Updated} coiUpdated={coiUpdated} voidedCheckUpdated={voidedCheckUpdated} intWireUpdated={intWireUpdated} businessClassificationUpdated={businessClassificationUpdated} /> 
                }
            </div>
        </div>
    )
};


export default NewVendor;